var items = {
  "block.minecraft.acacia_button": "Bouton en acacia",
  "block.minecraft.acacia_door": "Porte en acacia",
  "block.minecraft.acacia_fence": "Clôture en acacia",
  "block.minecraft.acacia_fence_gate": "Porte de clôture en acacia",
  "block.minecraft.acacia_hanging_sign": "Pancarte suspendue en acacia",
  "block.minecraft.acacia_leaves": "Feuilles d'acacia",
  "block.minecraft.acacia_log": "Bûche d'acacia",
  "block.minecraft.acacia_planks": "Planches d'acacia",
  "block.minecraft.acacia_pressure_plate": "Plaque de pression en acacia",
  "block.minecraft.acacia_sapling": "Pousse d'acacia",
  "block.minecraft.acacia_shelf": "Étagère en acacia",
  "block.minecraft.acacia_sign": "Pancarte en acacia",
  "block.minecraft.acacia_slab": "Dalle en acacia",
  "block.minecraft.acacia_stairs": "Escaliers en acacia",
  "block.minecraft.acacia_trapdoor": "Trappe en acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Pancarte suspendue murale en acacia",
  "block.minecraft.acacia_wall_sign": "Pancarte murale en acacia",
  "block.minecraft.acacia_wood": "Bois d'acacia",
  "block.minecraft.activator_rail": "Rails déclencheurs",
  "block.minecraft.air": "Air",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloc d'améthyste",
  "block.minecraft.amethyst_cluster": "Agglomérat d'améthyste",
  "block.minecraft.ancient_debris": "Débris antiques",
  "block.minecraft.andesite": "Andésite",
  "block.minecraft.andesite_slab": "Dalle d'andésite",
  "block.minecraft.andesite_stairs": "Escaliers d'andésite",
  "block.minecraft.andesite_wall": "Muret d'andésite",
  "block.minecraft.anvil": "Enclume",
  "block.minecraft.attached_melon_stem": "Tige de melon d'eau attachée",
  "block.minecraft.attached_pumpkin_stem": "Tige de citrouille attachée",
  "block.minecraft.azalea": "Azalée",
  "block.minecraft.azalea_leaves": "Feuilles d'azalée",
  "block.minecraft.azure_bluet": "Houstonies bleues",
  "block.minecraft.bamboo": "Bambou",
  "block.minecraft.bamboo_block": "Bloc de bambou",
  "block.minecraft.bamboo_button": "Bouton en bambou",
  "block.minecraft.bamboo_door": "Porte en bambou",
  "block.minecraft.bamboo_fence": "Clôture en bambou",
  "block.minecraft.bamboo_fence_gate": "Porte de clôture en bambou",
  "block.minecraft.bamboo_hanging_sign": "Pancarte suspendue en bambou",
  "block.minecraft.bamboo_mosaic": "Mosaïque de bambou",
  "block.minecraft.bamboo_mosaic_slab": "Dalle de mosaïque de bambou",
  "block.minecraft.bamboo_mosaic_stairs": "Escaliers de mosaïque de bambou",
  "block.minecraft.bamboo_planks": "Planches de bambou",
  "block.minecraft.bamboo_pressure_plate": "Plaque de pression en bambou",
  "block.minecraft.bamboo_sapling": "Pousse de bambou",
  "block.minecraft.bamboo_shelf": "Étagère en bambou",
  "block.minecraft.bamboo_sign": "Pancarte en bambou",
  "block.minecraft.bamboo_slab": "Dalle en bambou",
  "block.minecraft.bamboo_stairs": "Escaliers en bambou",
  "block.minecraft.bamboo_trapdoor": "Trappe en bambou",
  "block.minecraft.bamboo_wall_hanging_sign": "Pancarte suspendue murale en bambou",
  "block.minecraft.bamboo_wall_sign": "Pancarte murale en bambou",
  "block.minecraft.banner.base.black": "Champ de sable plain",
  "block.minecraft.banner.base.blue": "Champ d'azur plain",
  "block.minecraft.banner.base.brown": "Champ de tanné plain",
  "block.minecraft.banner.base.cyan": "Champ de cyan plain",
  "block.minecraft.banner.base.gray": "Champ d'acier plain",
  "block.minecraft.banner.base.green": "Champ de sinople plain",
  "block.minecraft.banner.base.light_blue": "Champ de bleu céleste plain",
  "block.minecraft.banner.base.light_gray": "Champ d'argent grisé plain",
  "block.minecraft.banner.base.lime": "Champ de sinople clair plain",
  "block.minecraft.banner.base.magenta": "Champ de pourpre plain",
  "block.minecraft.banner.base.orange": "Champ d'orangé plain",
  "block.minecraft.banner.base.pink": "Champ de carnation plain",
  "block.minecraft.banner.base.purple": "Champ de mûre plain",
  "block.minecraft.banner.base.red": "Champ de gueules plain",
  "block.minecraft.banner.base.white": "Champ d'argent plain",
  "block.minecraft.banner.base.yellow": "Champ d'or plain",
  "block.minecraft.banner.border.black": "Bordure de sable",
  "block.minecraft.banner.border.blue": "Bordure d'azur",
  "block.minecraft.banner.border.brown": "Bordure de tanné",
  "block.minecraft.banner.border.cyan": "Bordure de cyan",
  "block.minecraft.banner.border.gray": "Bordure d'acier",
  "block.minecraft.banner.border.green": "Bordure de sinople",
  "block.minecraft.banner.border.light_blue": "Bordure de bleu céleste",
  "block.minecraft.banner.border.light_gray": "Bordure d'argent grisé",
  "block.minecraft.banner.border.lime": "Bordure de sinople clair",
  "block.minecraft.banner.border.magenta": "Bordure de pourpre",
  "block.minecraft.banner.border.orange": "Bordure d'orangé",
  "block.minecraft.banner.border.pink": "Bordure de carnation",
  "block.minecraft.banner.border.purple": "Bordure de mûre",
  "block.minecraft.banner.border.red": "Bordure de gueules",
  "block.minecraft.banner.border.white": "Bordure d'argent",
  "block.minecraft.banner.border.yellow": "Bordure d'or",
  "block.minecraft.banner.bricks.black": "Champ maçonné de sable",
  "block.minecraft.banner.bricks.blue": "Champ maçonné d'azur",
  "block.minecraft.banner.bricks.brown": "Champ maçonné de tanné",
  "block.minecraft.banner.bricks.cyan": "Champ maçonné de cyan",
  "block.minecraft.banner.bricks.gray": "Champ maçonné d'acier",
  "block.minecraft.banner.bricks.green": "Champ maçonné de sinople",
  "block.minecraft.banner.bricks.light_blue": "Champ maçonné de bleu céleste",
  "block.minecraft.banner.bricks.light_gray": "Champ maçonné d'argent grisé",
  "block.minecraft.banner.bricks.lime": "Champ maçonné de sinople clair",
  "block.minecraft.banner.bricks.magenta": "Champ maçonné de pourpre",
  "block.minecraft.banner.bricks.orange": "Champ maçonné d'orangé",
  "block.minecraft.banner.bricks.pink": "Champ maçonné de carnation",
  "block.minecraft.banner.bricks.purple": "Champ maçonné de mûre",
  "block.minecraft.banner.bricks.red": "Champ maçonné de gueules",
  "block.minecraft.banner.bricks.white": "Champ maçonné d'argent",
  "block.minecraft.banner.bricks.yellow": "Champ maçonné d'or",
  "block.minecraft.banner.circle.black": "Tourteau de sable",
  "block.minecraft.banner.circle.blue": "Tourteau d'azur",
  "block.minecraft.banner.circle.brown": "Tourteau de tanné",
  "block.minecraft.banner.circle.cyan": "Tourteau de cyan",
  "block.minecraft.banner.circle.gray": "Tourteau d'acier",
  "block.minecraft.banner.circle.green": "Tourteau de sinople",
  "block.minecraft.banner.circle.light_blue": "Tourteau de bleu céleste",
  "block.minecraft.banner.circle.light_gray": "Tourteau d'argent grisé",
  "block.minecraft.banner.circle.lime": "Tourteau de sinople clair",
  "block.minecraft.banner.circle.magenta": "Tourteau de pourpre",
  "block.minecraft.banner.circle.orange": "Tourteau d'orangé",
  "block.minecraft.banner.circle.pink": "Tourteau de carnation",
  "block.minecraft.banner.circle.purple": "Tourteau de mûre",
  "block.minecraft.banner.circle.red": "Tourteau de gueules",
  "block.minecraft.banner.circle.white": "Besant d'argent",
  "block.minecraft.banner.circle.yellow": "Besant d'or",
  "block.minecraft.banner.creeper.black": "Face de Creeper de sable",
  "block.minecraft.banner.creeper.blue": "Face de Creeper d'azur",
  "block.minecraft.banner.creeper.brown": "Face de Creeper de tanné",
  "block.minecraft.banner.creeper.cyan": "Face de Creeper de cyan",
  "block.minecraft.banner.creeper.gray": "Face de Creeper d'acier",
  "block.minecraft.banner.creeper.green": "Face de Creeper de sinople",
  "block.minecraft.banner.creeper.light_blue": "Face de Creeper de bleu céleste",
  "block.minecraft.banner.creeper.light_gray": "Face de Creeper d'argent grisé",
  "block.minecraft.banner.creeper.lime": "Face de Creeper de sinople clair",
  "block.minecraft.banner.creeper.magenta": "Face de Creeper de pourpre",
  "block.minecraft.banner.creeper.orange": "Face de Creeper d'orangé",
  "block.minecraft.banner.creeper.pink": "Face de Creeper de carnation",
  "block.minecraft.banner.creeper.purple": "Face de Creeper de mûre",
  "block.minecraft.banner.creeper.red": "Face de Creeper de gueules",
  "block.minecraft.banner.creeper.white": "Face de Creeper d'argent",
  "block.minecraft.banner.creeper.yellow": "Face de Creeper d'or",
  "block.minecraft.banner.cross.black": "Sautoir de sable",
  "block.minecraft.banner.cross.blue": "Sautoir d'azur",
  "block.minecraft.banner.cross.brown": "Sautoir de tanné",
  "block.minecraft.banner.cross.cyan": "Sautoir de cyan",
  "block.minecraft.banner.cross.gray": "Sautoir d'acier",
  "block.minecraft.banner.cross.green": "Sautoir de sinople",
  "block.minecraft.banner.cross.light_blue": "Sautoir de bleu céleste",
  "block.minecraft.banner.cross.light_gray": "Sautoir d'argent grisé",
  "block.minecraft.banner.cross.lime": "Sautoir de sinople clair",
  "block.minecraft.banner.cross.magenta": "Sautoir de pourpre",
  "block.minecraft.banner.cross.orange": "Sautoir d'orangé",
  "block.minecraft.banner.cross.pink": "Sautoir de carnation",
  "block.minecraft.banner.cross.purple": "Sautoir de mûre",
  "block.minecraft.banner.cross.red": "Sautoir de gueules",
  "block.minecraft.banner.cross.white": "Sautoir d'argent",
  "block.minecraft.banner.cross.yellow": "Sautoir d'or",
  "block.minecraft.banner.curly_border.black": "Bordure endentée de sable",
  "block.minecraft.banner.curly_border.blue": "Bordure endentée d'azur",
  "block.minecraft.banner.curly_border.brown": "Bordure endentée de tanné",
  "block.minecraft.banner.curly_border.cyan": "Bordure endentée de cyan",
  "block.minecraft.banner.curly_border.gray": "Bordure endentée d'acier",
  "block.minecraft.banner.curly_border.green": "Bordure endentée de sinople",
  "block.minecraft.banner.curly_border.light_blue": "Bordure endentée de bleu céleste",
  "block.minecraft.banner.curly_border.light_gray": "Bordure endentée d'argent grisé",
  "block.minecraft.banner.curly_border.lime": "Bordure endentée de sinople clair",
  "block.minecraft.banner.curly_border.magenta": "Bordure endentée de pourpre",
  "block.minecraft.banner.curly_border.orange": "Bordure endentée d'orangé",
  "block.minecraft.banner.curly_border.pink": "Bordure endentée de carnation",
  "block.minecraft.banner.curly_border.purple": "Bordure endentée de mûre",
  "block.minecraft.banner.curly_border.red": "Bordure endentée de gueules",
  "block.minecraft.banner.curly_border.white": "Bordure endentée d'argent",
  "block.minecraft.banner.curly_border.yellow": "Bordure endentée d'or",
  "block.minecraft.banner.diagonal_left.black": "Taillé, au premier de sable",
  "block.minecraft.banner.diagonal_left.blue": "Taillé, au premier d'azur",
  "block.minecraft.banner.diagonal_left.brown": "Taillé, au premier de tanné",
  "block.minecraft.banner.diagonal_left.cyan": "Taillé, au premier de cyan",
  "block.minecraft.banner.diagonal_left.gray": "Taillé, au premier d'acier",
  "block.minecraft.banner.diagonal_left.green": "Taillé, au premier de sinople",
  "block.minecraft.banner.diagonal_left.light_blue": "Taillé, au premier de bleu céleste",
  "block.minecraft.banner.diagonal_left.light_gray": "Taillé, au premier d'argent grisé",
  "block.minecraft.banner.diagonal_left.lime": "Taillé, au premier de sinople clair",
  "block.minecraft.banner.diagonal_left.magenta": "Taillé, au premier de pourpre",
  "block.minecraft.banner.diagonal_left.orange": "Taillé, au premier d'orangé",
  "block.minecraft.banner.diagonal_left.pink": "Taillé, au premier de carnation",
  "block.minecraft.banner.diagonal_left.purple": "Taillé, au premier de mûre",
  "block.minecraft.banner.diagonal_left.red": "Taillé, au premier de gueules",
  "block.minecraft.banner.diagonal_left.white": "Taillé, au premier d'argent",
  "block.minecraft.banner.diagonal_left.yellow": "Taillé, au premier d'or",
  "block.minecraft.banner.diagonal_right.black": "Tranché, au premier de sable",
  "block.minecraft.banner.diagonal_right.blue": "Tranché, au premier d'azur",
  "block.minecraft.banner.diagonal_right.brown": "Tranché, au premier de tanné",
  "block.minecraft.banner.diagonal_right.cyan": "Tranché, au premier de cyan",
  "block.minecraft.banner.diagonal_right.gray": "Tranché, au premier d'acier",
  "block.minecraft.banner.diagonal_right.green": "Tranché, au premier de sinople",
  "block.minecraft.banner.diagonal_right.light_blue": "Tranché, au premier de bleu céleste",
  "block.minecraft.banner.diagonal_right.light_gray": "Tranché, au premier d'argent grisé",
  "block.minecraft.banner.diagonal_right.lime": "Tranché, au premier de sinople clair",
  "block.minecraft.banner.diagonal_right.magenta": "Tranché, au premier de pourpre",
  "block.minecraft.banner.diagonal_right.orange": "Tranché, au premier d'orangé",
  "block.minecraft.banner.diagonal_right.pink": "Tranché, au premier de carnation",
  "block.minecraft.banner.diagonal_right.purple": "Tranché, au premier de mûre",
  "block.minecraft.banner.diagonal_right.red": "Tranché, au premier de gueules",
  "block.minecraft.banner.diagonal_right.white": "Tranché, au premier d'argent",
  "block.minecraft.banner.diagonal_right.yellow": "Tranché, au premier d'or",
  "block.minecraft.banner.diagonal_up_left.black": "Tranché, au second de sable",
  "block.minecraft.banner.diagonal_up_left.blue": "Tranché, au second d'azur",
  "block.minecraft.banner.diagonal_up_left.brown": "Tranché, au second de tanné",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tranché, au second de cyan",
  "block.minecraft.banner.diagonal_up_left.gray": "Tranché, au second d'acier",
  "block.minecraft.banner.diagonal_up_left.green": "Tranché, au second de sinople",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tranché, au second de bleu céleste",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tranché, au second d'argent grisé",
  "block.minecraft.banner.diagonal_up_left.lime": "Tranché, au second de sinople clair",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tranché, au second de pourpre",
  "block.minecraft.banner.diagonal_up_left.orange": "Tranché, au second d'orangé",
  "block.minecraft.banner.diagonal_up_left.pink": "Tranché, au second de carnation",
  "block.minecraft.banner.diagonal_up_left.purple": "Tranché, au second de mûre",
  "block.minecraft.banner.diagonal_up_left.red": "Tranché, au second de gueules",
  "block.minecraft.banner.diagonal_up_left.white": "Tranché, au second d'argent",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tranché, au second d'or",
  "block.minecraft.banner.diagonal_up_right.black": "Taillé, au second de sable",
  "block.minecraft.banner.diagonal_up_right.blue": "Taillé, au second d'azur",
  "block.minecraft.banner.diagonal_up_right.brown": "Taillé, au second de tanné",
  "block.minecraft.banner.diagonal_up_right.cyan": "Taillé, au second de cyan",
  "block.minecraft.banner.diagonal_up_right.gray": "Taillé, au second d'acier",
  "block.minecraft.banner.diagonal_up_right.green": "Taillé, au second de sinople",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Taillé, au second de bleu céleste",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Taillé, au second d'argent grisé",
  "block.minecraft.banner.diagonal_up_right.lime": "Taillé, au second de sinople clair",
  "block.minecraft.banner.diagonal_up_right.magenta": "Taillé, au second de pourpre",
  "block.minecraft.banner.diagonal_up_right.orange": "Taillé, au second d'orangé",
  "block.minecraft.banner.diagonal_up_right.pink": "Taillé, au second de carnation",
  "block.minecraft.banner.diagonal_up_right.purple": "Taillé, au second de mûre",
  "block.minecraft.banner.diagonal_up_right.red": "Taillé, au second de gueules",
  "block.minecraft.banner.diagonal_up_right.white": "Taillé, au second d'argent",
  "block.minecraft.banner.diagonal_up_right.yellow": "Taillé, au second d'or",
  "block.minecraft.banner.flow.black": "Tourbillon de sable",
  "block.minecraft.banner.flow.blue": "Tourbillon d'azur",
  "block.minecraft.banner.flow.brown": "Tourbillon de tanné",
  "block.minecraft.banner.flow.cyan": "Tourbillon de cyan",
  "block.minecraft.banner.flow.gray": "Tourbillon d'acier",
  "block.minecraft.banner.flow.green": "Tourbillon de sinople",
  "block.minecraft.banner.flow.light_blue": "Tourbillon de bleu céleste",
  "block.minecraft.banner.flow.light_gray": "Tourbillon d'argent grisé",
  "block.minecraft.banner.flow.lime": "Tourbillon de sinople clair",
  "block.minecraft.banner.flow.magenta": "Tourbillon de pourpre",
  "block.minecraft.banner.flow.orange": "Tourbillon d'orangé",
  "block.minecraft.banner.flow.pink": "Tourbillon de carnation",
  "block.minecraft.banner.flow.purple": "Tourbillon de mûre",
  "block.minecraft.banner.flow.red": "Tourbillon de gueules",
  "block.minecraft.banner.flow.white": "Tourbillon d'argent",
  "block.minecraft.banner.flow.yellow": "Tourbillon d'or",
  "block.minecraft.banner.flower.black": "Fleur de sable",
  "block.minecraft.banner.flower.blue": "Fleur d'azur",
  "block.minecraft.banner.flower.brown": "Fleur de tanné",
  "block.minecraft.banner.flower.cyan": "Fleur de cyan",
  "block.minecraft.banner.flower.gray": "Fleur d'acier",
  "block.minecraft.banner.flower.green": "Fleur de sinople",
  "block.minecraft.banner.flower.light_blue": "Fleur de bleu céleste",
  "block.minecraft.banner.flower.light_gray": "Fleur d'argent grisé",
  "block.minecraft.banner.flower.lime": "Fleur de sinople clair",
  "block.minecraft.banner.flower.magenta": "Fleur de pourpre",
  "block.minecraft.banner.flower.orange": "Fleur d'orangé",
  "block.minecraft.banner.flower.pink": "Fleur de carnation",
  "block.minecraft.banner.flower.purple": "Fleur de mûre",
  "block.minecraft.banner.flower.red": "Fleur de gueules",
  "block.minecraft.banner.flower.white": "Fleur d'argent",
  "block.minecraft.banner.flower.yellow": "Fleur d'or",
  "block.minecraft.banner.globe.black": "Globe de sable",
  "block.minecraft.banner.globe.blue": "Globe d'azur",
  "block.minecraft.banner.globe.brown": "Globe de tanné",
  "block.minecraft.banner.globe.cyan": "Globe de cyan",
  "block.minecraft.banner.globe.gray": "Globe d'acier",
  "block.minecraft.banner.globe.green": "Globe de sinople",
  "block.minecraft.banner.globe.light_blue": "Globe de bleu céleste",
  "block.minecraft.banner.globe.light_gray": "Globe d'argent grisé",
  "block.minecraft.banner.globe.lime": "Globe de sinople clair",
  "block.minecraft.banner.globe.magenta": "Globe de pourpre",
  "block.minecraft.banner.globe.orange": "Globe d'orangé",
  "block.minecraft.banner.globe.pink": "Globe de carnation",
  "block.minecraft.banner.globe.purple": "Globe de mûre",
  "block.minecraft.banner.globe.red": "Globe de gueules",
  "block.minecraft.banner.globe.white": "Globe d'argent",
  "block.minecraft.banner.globe.yellow": "Globe d'or",
  "block.minecraft.banner.gradient.black": "Dégradé de sable du chef",
  "block.minecraft.banner.gradient.blue": "Dégradé d'azur du chef",
  "block.minecraft.banner.gradient.brown": "Dégradé de tanné du chef",
  "block.minecraft.banner.gradient.cyan": "Dégradé de cyan du chef",
  "block.minecraft.banner.gradient.gray": "Dégradé d'acier du chef",
  "block.minecraft.banner.gradient.green": "Dégradé de sinople du chef",
  "block.minecraft.banner.gradient.light_blue": "Dégradé de bleu céleste du chef",
  "block.minecraft.banner.gradient.light_gray": "Dégradé d'argent grisé du chef",
  "block.minecraft.banner.gradient.lime": "Dégradé de sinople clair du chef",
  "block.minecraft.banner.gradient.magenta": "Dégradé de pourpre du chef",
  "block.minecraft.banner.gradient.orange": "Dégradé d'orangé du chef",
  "block.minecraft.banner.gradient.pink": "Dégradé de carnation du chef",
  "block.minecraft.banner.gradient.purple": "Dégradé de mûre du chef",
  "block.minecraft.banner.gradient.red": "Dégradé de gueules du chef",
  "block.minecraft.banner.gradient.white": "Dégradé d'argent du chef",
  "block.minecraft.banner.gradient.yellow": "Dégradé d'or du chef",
  "block.minecraft.banner.gradient_up.black": "Dégradé de sable de la pointe",
  "block.minecraft.banner.gradient_up.blue": "Dégradé d'azur de la pointe",
  "block.minecraft.banner.gradient_up.brown": "Dégradé de tanné de la pointe",
  "block.minecraft.banner.gradient_up.cyan": "Dégradé de cyan de la pointe",
  "block.minecraft.banner.gradient_up.gray": "Dégradé d'acier de la pointe",
  "block.minecraft.banner.gradient_up.green": "Dégradé de sinople de la pointe",
  "block.minecraft.banner.gradient_up.light_blue": "Dégradé de bleu céleste de la pointe",
  "block.minecraft.banner.gradient_up.light_gray": "Dégradé d'argent grisé de la pointe",
  "block.minecraft.banner.gradient_up.lime": "Dégradé de sinople clair de la pointe",
  "block.minecraft.banner.gradient_up.magenta": "Dégradé de pourpre de la pointe",
  "block.minecraft.banner.gradient_up.orange": "Dégradé d'orangé de la pointe",
  "block.minecraft.banner.gradient_up.pink": "Dégradé de carnation de la pointe",
  "block.minecraft.banner.gradient_up.purple": "Dégradé de mûre de la pointe",
  "block.minecraft.banner.gradient_up.red": "Dégradé de gueules de la pointe",
  "block.minecraft.banner.gradient_up.white": "Dégradé d'argent de la pointe",
  "block.minecraft.banner.gradient_up.yellow": "Dégradé d'or de la pointe",
  "block.minecraft.banner.guster.black": "Rafaleur de sable",
  "block.minecraft.banner.guster.blue": "Rafaleur d'azur",
  "block.minecraft.banner.guster.brown": "Rafaleur de tanné",
  "block.minecraft.banner.guster.cyan": "Rafaleur de cyan",
  "block.minecraft.banner.guster.gray": "Rafaleur d'acier",
  "block.minecraft.banner.guster.green": "Rafaleur de sinople",
  "block.minecraft.banner.guster.light_blue": "Rafaleur de bleu céleste",
  "block.minecraft.banner.guster.light_gray": "Rafaleur d'argent grisé",
  "block.minecraft.banner.guster.lime": "Rafaleur de sinople clair",
  "block.minecraft.banner.guster.magenta": "Rafaleur de pourpre",
  "block.minecraft.banner.guster.orange": "Rafaleur d'orangé",
  "block.minecraft.banner.guster.pink": "Rafaleur de carnation",
  "block.minecraft.banner.guster.purple": "Rafaleur de mûre",
  "block.minecraft.banner.guster.red": "Rafaleur de gueules",
  "block.minecraft.banner.guster.white": "Rafaleur d'argent",
  "block.minecraft.banner.guster.yellow": "Rafaleur d'or",
  "block.minecraft.banner.half_horizontal.black": "Coupé, au premier de sable",
  "block.minecraft.banner.half_horizontal.blue": "Coupé, au premier d'azur",
  "block.minecraft.banner.half_horizontal.brown": "Coupé, au premier de tanné",
  "block.minecraft.banner.half_horizontal.cyan": "Coupé, au premier de cyan",
  "block.minecraft.banner.half_horizontal.gray": "Coupé, au premier d'acier",
  "block.minecraft.banner.half_horizontal.green": "Coupé, au premier de sinople",
  "block.minecraft.banner.half_horizontal.light_blue": "Coupé, au premier de bleu céleste",
  "block.minecraft.banner.half_horizontal.light_gray": "Coupé, au premier d'argent grisé",
  "block.minecraft.banner.half_horizontal.lime": "Coupé, au premier de sinople clair",
  "block.minecraft.banner.half_horizontal.magenta": "Coupé, au premier de pourpre",
  "block.minecraft.banner.half_horizontal.orange": "Coupé, au premier d'orangé",
  "block.minecraft.banner.half_horizontal.pink": "Coupé, au premier de carnation",
  "block.minecraft.banner.half_horizontal.purple": "Coupé, au premier de mûre",
  "block.minecraft.banner.half_horizontal.red": "Coupé, au premier de gueules",
  "block.minecraft.banner.half_horizontal.white": "Coupé, au premier d'argent",
  "block.minecraft.banner.half_horizontal.yellow": "Coupé, au premier d'or",
  "block.minecraft.banner.half_horizontal_bottom.black": "Coupé, au second de sable",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Coupé, au second d'azur",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Coupé, au second de tanné",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Coupé, au second de cyan",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Coupé, au second d'acier",
  "block.minecraft.banner.half_horizontal_bottom.green": "Coupé, au second de sinople",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Coupé, au second de bleu céleste",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Coupé, au second d'argent grisé",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Coupé, au second de sinople clair",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Coupé, au second de pourpre",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Coupé, au second d'orangé",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Coupé, au second de carnation",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Coupé, au second de mûre",
  "block.minecraft.banner.half_horizontal_bottom.red": "Coupé, au second de gueules",
  "block.minecraft.banner.half_horizontal_bottom.white": "Coupé, au second d'argent",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Coupé, au second d'or",
  "block.minecraft.banner.half_vertical.black": "Parti, au premier de sable",
  "block.minecraft.banner.half_vertical.blue": "Parti, au premier d'azur",
  "block.minecraft.banner.half_vertical.brown": "Parti, au premier de tanné",
  "block.minecraft.banner.half_vertical.cyan": "Parti, au premier de cyan",
  "block.minecraft.banner.half_vertical.gray": "Parti, au premier d'acier",
  "block.minecraft.banner.half_vertical.green": "Parti, au premier de sinople",
  "block.minecraft.banner.half_vertical.light_blue": "Parti, au premier de bleu céleste",
  "block.minecraft.banner.half_vertical.light_gray": "Parti, au premier d'argent grisé",
  "block.minecraft.banner.half_vertical.lime": "Parti, au premier de sinople clair",
  "block.minecraft.banner.half_vertical.magenta": "Parti, au premier de pourpre",
  "block.minecraft.banner.half_vertical.orange": "Parti, au premier d'orangé",
  "block.minecraft.banner.half_vertical.pink": "Parti, au premier de carnation",
  "block.minecraft.banner.half_vertical.purple": "Parti, au premier de mûre",
  "block.minecraft.banner.half_vertical.red": "Parti, au premier de gueules",
  "block.minecraft.banner.half_vertical.white": "Parti, au premier d'argent",
  "block.minecraft.banner.half_vertical.yellow": "Parti, au premier d'or",
  "block.minecraft.banner.half_vertical_right.black": "Parti, au second de sable",
  "block.minecraft.banner.half_vertical_right.blue": "Parti, au second d'azur",
  "block.minecraft.banner.half_vertical_right.brown": "Parti, au second de tanné",
  "block.minecraft.banner.half_vertical_right.cyan": "Parti, au second de cyan",
  "block.minecraft.banner.half_vertical_right.gray": "Parti, au second d'acier",
  "block.minecraft.banner.half_vertical_right.green": "Parti, au second de sinople",
  "block.minecraft.banner.half_vertical_right.light_blue": "Parti, au second de bleu céleste",
  "block.minecraft.banner.half_vertical_right.light_gray": "Parti, au second d'argent grisé",
  "block.minecraft.banner.half_vertical_right.lime": "Parti, au second de sinople clair",
  "block.minecraft.banner.half_vertical_right.magenta": "Parti, au second de pourpre",
  "block.minecraft.banner.half_vertical_right.orange": "Parti, au second d'orangé",
  "block.minecraft.banner.half_vertical_right.pink": "Parti, au second de carnation",
  "block.minecraft.banner.half_vertical_right.purple": "Parti, au second de mûre",
  "block.minecraft.banner.half_vertical_right.red": "Parti, au second de gueules",
  "block.minecraft.banner.half_vertical_right.white": "Parti, au second d'argent",
  "block.minecraft.banner.half_vertical_right.yellow": "Parti, au second d'or",
  "block.minecraft.banner.mojang.black": "Emblème de sable",
  "block.minecraft.banner.mojang.blue": "Emblème d'azur",
  "block.minecraft.banner.mojang.brown": "Emblème de tanné",
  "block.minecraft.banner.mojang.cyan": "Emblème de cyan",
  "block.minecraft.banner.mojang.gray": "Emblème d'acier",
  "block.minecraft.banner.mojang.green": "Emblème de sinople",
  "block.minecraft.banner.mojang.light_blue": "Emblème de bleu céleste",
  "block.minecraft.banner.mojang.light_gray": "Emblème d'argent grisé",
  "block.minecraft.banner.mojang.lime": "Emblème de sinople clair",
  "block.minecraft.banner.mojang.magenta": "Emblème de pourpre",
  "block.minecraft.banner.mojang.orange": "Emblème d'orangé",
  "block.minecraft.banner.mojang.pink": "Emblème de carnation",
  "block.minecraft.banner.mojang.purple": "Emblème de mûre",
  "block.minecraft.banner.mojang.red": "Emblème de gueules",
  "block.minecraft.banner.mojang.white": "Emblème d'argent",
  "block.minecraft.banner.mojang.yellow": "Emblème d'or",
  "block.minecraft.banner.piglin.black": "Groin de sable",
  "block.minecraft.banner.piglin.blue": "Groin d'azur",
  "block.minecraft.banner.piglin.brown": "Groin de tanné",
  "block.minecraft.banner.piglin.cyan": "Groin de cyan",
  "block.minecraft.banner.piglin.gray": "Groin d'acier",
  "block.minecraft.banner.piglin.green": "Groin de sinople",
  "block.minecraft.banner.piglin.light_blue": "Groin de bleu céleste",
  "block.minecraft.banner.piglin.light_gray": "Groin d'argent grisé",
  "block.minecraft.banner.piglin.lime": "Groin de sinople clair",
  "block.minecraft.banner.piglin.magenta": "Groin de pourpre",
  "block.minecraft.banner.piglin.orange": "Groin d'orangé",
  "block.minecraft.banner.piglin.pink": "Groin de carnation",
  "block.minecraft.banner.piglin.purple": "Groin de mûre",
  "block.minecraft.banner.piglin.red": "Groin de gueules",
  "block.minecraft.banner.piglin.white": "Groin d'argent",
  "block.minecraft.banner.piglin.yellow": "Groin d'or",
  "block.minecraft.banner.rhombus.black": "Losange de sable",
  "block.minecraft.banner.rhombus.blue": "Losange d'azur",
  "block.minecraft.banner.rhombus.brown": "Losange de tanné",
  "block.minecraft.banner.rhombus.cyan": "Losange de cyan",
  "block.minecraft.banner.rhombus.gray": "Losange d'acier",
  "block.minecraft.banner.rhombus.green": "Losange de sinople",
  "block.minecraft.banner.rhombus.light_blue": "Losange de bleu céleste",
  "block.minecraft.banner.rhombus.light_gray": "Losange d'argent grisé",
  "block.minecraft.banner.rhombus.lime": "Losange de sinople clair",
  "block.minecraft.banner.rhombus.magenta": "Losange de pourpre",
  "block.minecraft.banner.rhombus.orange": "Losange d'orangé",
  "block.minecraft.banner.rhombus.pink": "Losange de carnation",
  "block.minecraft.banner.rhombus.purple": "Losange de mûre",
  "block.minecraft.banner.rhombus.red": "Losange de gueules",
  "block.minecraft.banner.rhombus.white": "Losange d'argent",
  "block.minecraft.banner.rhombus.yellow": "Losange d'or",
  "block.minecraft.banner.skull.black": "Tête de mort de sable",
  "block.minecraft.banner.skull.blue": "Tête de mort d'azur",
  "block.minecraft.banner.skull.brown": "Tête de mort de tanné",
  "block.minecraft.banner.skull.cyan": "Tête de mort de cyan",
  "block.minecraft.banner.skull.gray": "Tête de mort d'acier",
  "block.minecraft.banner.skull.green": "Tête de mort de sinople",
  "block.minecraft.banner.skull.light_blue": "Tête de mort de bleu céleste",
  "block.minecraft.banner.skull.light_gray": "Tête de mort d'argent grisé",
  "block.minecraft.banner.skull.lime": "Tête de mort de sinople clair",
  "block.minecraft.banner.skull.magenta": "Tête de mort de pourpre",
  "block.minecraft.banner.skull.orange": "Tête de mort d'orangé",
  "block.minecraft.banner.skull.pink": "Tête de mort de carnation",
  "block.minecraft.banner.skull.purple": "Tête de mort de mûre",
  "block.minecraft.banner.skull.red": "Tête de mort de gueules",
  "block.minecraft.banner.skull.white": "Tête de mort d'argent",
  "block.minecraft.banner.skull.yellow": "Tête de mort d'or",
  "block.minecraft.banner.small_stripes.black": "Quatre pals noirs",
  "block.minecraft.banner.small_stripes.blue": "Quatre pals bleus",
  "block.minecraft.banner.small_stripes.brown": "Quatre pals bruns",
  "block.minecraft.banner.small_stripes.cyan": "Quatre pals de cyan",
  "block.minecraft.banner.small_stripes.gray": "Quatre pals d'acier",
  "block.minecraft.banner.small_stripes.green": "Quatre pals verts",
  "block.minecraft.banner.small_stripes.light_blue": "Quatre pals de bleu céleste",
  "block.minecraft.banner.small_stripes.light_gray": "Quatre pals d'argent grisé",
  "block.minecraft.banner.small_stripes.lime": "Quatre pals de sinople clair",
  "block.minecraft.banner.small_stripes.magenta": "Quatre pals de pourpre",
  "block.minecraft.banner.small_stripes.orange": "Quatre pals d'orangé",
  "block.minecraft.banner.small_stripes.pink": "Quatre pals carnations",
  "block.minecraft.banner.small_stripes.purple": "Quatre pals mauves",
  "block.minecraft.banner.small_stripes.red": "Quatre pals rouges",
  "block.minecraft.banner.small_stripes.white": "Quatre pals blancs",
  "block.minecraft.banner.small_stripes.yellow": "Quatre pals jaunes",
  "block.minecraft.banner.square_bottom_left.black": "Canton dextre de la pointe de sable",
  "block.minecraft.banner.square_bottom_left.blue": "Canton dextre de la pointe d'azur",
  "block.minecraft.banner.square_bottom_left.brown": "Canton dextre de la pointe de tanné",
  "block.minecraft.banner.square_bottom_left.cyan": "Canton dextre de la pointe de cyan",
  "block.minecraft.banner.square_bottom_left.gray": "Canton dextre de la pointe d'acier",
  "block.minecraft.banner.square_bottom_left.green": "Canton dextre de la pointe de sinople",
  "block.minecraft.banner.square_bottom_left.light_blue": "Canton dextre de la pointe de bleu céleste",
  "block.minecraft.banner.square_bottom_left.light_gray": "Canton dextre de la pointe d'argent grisé",
  "block.minecraft.banner.square_bottom_left.lime": "Canton dextre de la pointe de sinople clair",
  "block.minecraft.banner.square_bottom_left.magenta": "Canton dextre de la pointe de pourpre",
  "block.minecraft.banner.square_bottom_left.orange": "Canton dextre de la pointe d'orangé",
  "block.minecraft.banner.square_bottom_left.pink": "Canton dextre de la pointe de carnation",
  "block.minecraft.banner.square_bottom_left.purple": "Canton dextre de la pointe de mûre",
  "block.minecraft.banner.square_bottom_left.red": "Canton dextre de la pointe de gueules",
  "block.minecraft.banner.square_bottom_left.white": "Canton dextre de la pointe d'argent",
  "block.minecraft.banner.square_bottom_left.yellow": "Canton dextre de la pointe d'or",
  "block.minecraft.banner.square_bottom_right.black": "Canton senestre de la pointe de sable",
  "block.minecraft.banner.square_bottom_right.blue": "Canton senestre de la pointe d'azur",
  "block.minecraft.banner.square_bottom_right.brown": "Canton senestre de la pointe de tanné",
  "block.minecraft.banner.square_bottom_right.cyan": "Canton senestre de la pointe de cyan",
  "block.minecraft.banner.square_bottom_right.gray": "Canton senestre de la pointe d'acier",
  "block.minecraft.banner.square_bottom_right.green": "Canton senestre de la pointe de sinople",
  "block.minecraft.banner.square_bottom_right.light_blue": "Canton senestre de la pointe de bleu céleste",
  "block.minecraft.banner.square_bottom_right.light_gray": "Canton senestre de la pointe d'argent grisé",
  "block.minecraft.banner.square_bottom_right.lime": "Canton senestre de la pointe de sinople clair",
  "block.minecraft.banner.square_bottom_right.magenta": "Canton senestre de la pointe de pourpre",
  "block.minecraft.banner.square_bottom_right.orange": "Canton senestre de la pointe d'orangé",
  "block.minecraft.banner.square_bottom_right.pink": "Canton senestre de la pointe de carnation",
  "block.minecraft.banner.square_bottom_right.purple": "Canton senestre de la pointe de mûre",
  "block.minecraft.banner.square_bottom_right.red": "Canton senestre de la pointe de gueules",
  "block.minecraft.banner.square_bottom_right.white": "Canton senestre de la pointe d'argent",
  "block.minecraft.banner.square_bottom_right.yellow": "Canton senestre de la pointe d'or",
  "block.minecraft.banner.square_top_left.black": "Canton dextre du chef de sable",
  "block.minecraft.banner.square_top_left.blue": "Canton dextre du chef d'azur",
  "block.minecraft.banner.square_top_left.brown": "Canton dextre du chef de tanné",
  "block.minecraft.banner.square_top_left.cyan": "Canton dextre du chef de cyan",
  "block.minecraft.banner.square_top_left.gray": "Canton dextre du chef d'acier",
  "block.minecraft.banner.square_top_left.green": "Canton dextre du chef de sinople",
  "block.minecraft.banner.square_top_left.light_blue": "Canton dextre du chef de bleu céleste",
  "block.minecraft.banner.square_top_left.light_gray": "Canton dextre du chef d'argent grisé",
  "block.minecraft.banner.square_top_left.lime": "Canton dextre du chef de sinople clair",
  "block.minecraft.banner.square_top_left.magenta": "Canton dextre du chef de pourpre",
  "block.minecraft.banner.square_top_left.orange": "Canton dextre du chef d'orangé",
  "block.minecraft.banner.square_top_left.pink": "Canton dextre du chef de carnation",
  "block.minecraft.banner.square_top_left.purple": "Canton dextre du chef de mûre",
  "block.minecraft.banner.square_top_left.red": "Canton dextre du chef de gueules",
  "block.minecraft.banner.square_top_left.white": "Canton dextre du chef d'argent",
  "block.minecraft.banner.square_top_left.yellow": "Canton dextre du chef d'or",
  "block.minecraft.banner.square_top_right.black": "Canton senestre du chef de sable",
  "block.minecraft.banner.square_top_right.blue": "Canton senestre du chef d'azur",
  "block.minecraft.banner.square_top_right.brown": "Canton senestre du chef de tanné",
  "block.minecraft.banner.square_top_right.cyan": "Canton senestre du chef de cyan",
  "block.minecraft.banner.square_top_right.gray": "Canton senestre du chef d'acier",
  "block.minecraft.banner.square_top_right.green": "Canton senestre du chef de sinople",
  "block.minecraft.banner.square_top_right.light_blue": "Canton senestre du chef de bleu céleste",
  "block.minecraft.banner.square_top_right.light_gray": "Canton senestre du chef d'argent grisé",
  "block.minecraft.banner.square_top_right.lime": "Canton senestre du chef de sinople clair",
  "block.minecraft.banner.square_top_right.magenta": "Canton senestre du chef de pourpre",
  "block.minecraft.banner.square_top_right.orange": "Canton senestre du chef d'orangé",
  "block.minecraft.banner.square_top_right.pink": "Canton senestre du chef de carnation",
  "block.minecraft.banner.square_top_right.purple": "Canton senestre du chef de mûre",
  "block.minecraft.banner.square_top_right.red": "Canton senestre du chef de gueules",
  "block.minecraft.banner.square_top_right.white": "Canton senestre du chef d'argent",
  "block.minecraft.banner.square_top_right.yellow": "Canton senestre du chef d'or",
  "block.minecraft.banner.straight_cross.black": "Croix de sable",
  "block.minecraft.banner.straight_cross.blue": "Croix d'azur",
  "block.minecraft.banner.straight_cross.brown": "Croix de tanné",
  "block.minecraft.banner.straight_cross.cyan": "Croix de cyan",
  "block.minecraft.banner.straight_cross.gray": "Croix d'acier",
  "block.minecraft.banner.straight_cross.green": "Croix de sinople",
  "block.minecraft.banner.straight_cross.light_blue": "Croix de bleu céleste",
  "block.minecraft.banner.straight_cross.light_gray": "Croix d'argent grisé",
  "block.minecraft.banner.straight_cross.lime": "Croix de sinople clair",
  "block.minecraft.banner.straight_cross.magenta": "Croix de pourpre",
  "block.minecraft.banner.straight_cross.orange": "Croix d'orangé",
  "block.minecraft.banner.straight_cross.pink": "Croix de carnation",
  "block.minecraft.banner.straight_cross.purple": "Croix de mûre",
  "block.minecraft.banner.straight_cross.red": "Croix de gueules",
  "block.minecraft.banner.straight_cross.white": "Croix d'argent",
  "block.minecraft.banner.straight_cross.yellow": "Croix d'or",
  "block.minecraft.banner.stripe_bottom.black": "Champagne de sable",
  "block.minecraft.banner.stripe_bottom.blue": "Champagne d'azur",
  "block.minecraft.banner.stripe_bottom.brown": "Champagne de tanné",
  "block.minecraft.banner.stripe_bottom.cyan": "Champagne de cyan",
  "block.minecraft.banner.stripe_bottom.gray": "Champagne d'acier",
  "block.minecraft.banner.stripe_bottom.green": "Champagne de sinople",
  "block.minecraft.banner.stripe_bottom.light_blue": "Champagne de bleu céleste",
  "block.minecraft.banner.stripe_bottom.light_gray": "Champagne d'argent grisé",
  "block.minecraft.banner.stripe_bottom.lime": "Champagne de sinople clair",
  "block.minecraft.banner.stripe_bottom.magenta": "Champagne de pourpre",
  "block.minecraft.banner.stripe_bottom.orange": "Champagne d'orangé",
  "block.minecraft.banner.stripe_bottom.pink": "Champagne de carnation",
  "block.minecraft.banner.stripe_bottom.purple": "Champagne de mûre",
  "block.minecraft.banner.stripe_bottom.red": "Champagne de gueules",
  "block.minecraft.banner.stripe_bottom.white": "Champagne d'argent",
  "block.minecraft.banner.stripe_bottom.yellow": "Champagne d'or",
  "block.minecraft.banner.stripe_center.black": "Pal de sable",
  "block.minecraft.banner.stripe_center.blue": "Pal d'azur",
  "block.minecraft.banner.stripe_center.brown": "Pal de tanné",
  "block.minecraft.banner.stripe_center.cyan": "Pal de cyan",
  "block.minecraft.banner.stripe_center.gray": "Pal d'acier",
  "block.minecraft.banner.stripe_center.green": "Pal de sinople",
  "block.minecraft.banner.stripe_center.light_blue": "Pal de bleu céleste",
  "block.minecraft.banner.stripe_center.light_gray": "Pal d'argent grisé",
  "block.minecraft.banner.stripe_center.lime": "Pal de sinople clair",
  "block.minecraft.banner.stripe_center.magenta": "Pal de pourpre",
  "block.minecraft.banner.stripe_center.orange": "Pal d'orangé",
  "block.minecraft.banner.stripe_center.pink": "Pal de carnation",
  "block.minecraft.banner.stripe_center.purple": "Pal de mûre",
  "block.minecraft.banner.stripe_center.red": "Pal de gueules",
  "block.minecraft.banner.stripe_center.white": "Pal d'argent",
  "block.minecraft.banner.stripe_center.yellow": "Pal d'or",
  "block.minecraft.banner.stripe_downleft.black": "Barre de sable",
  "block.minecraft.banner.stripe_downleft.blue": "Barre d'azur",
  "block.minecraft.banner.stripe_downleft.brown": "Barre de tanné",
  "block.minecraft.banner.stripe_downleft.cyan": "Barre de cyan",
  "block.minecraft.banner.stripe_downleft.gray": "Barre d'acier",
  "block.minecraft.banner.stripe_downleft.green": "Barre de sinople",
  "block.minecraft.banner.stripe_downleft.light_blue": "Barre de bleu céleste",
  "block.minecraft.banner.stripe_downleft.light_gray": "Barre d'argent grisé",
  "block.minecraft.banner.stripe_downleft.lime": "Barre de sinople clair",
  "block.minecraft.banner.stripe_downleft.magenta": "Barre de pourpre",
  "block.minecraft.banner.stripe_downleft.orange": "Barre d'orangé",
  "block.minecraft.banner.stripe_downleft.pink": "Barre de carnation",
  "block.minecraft.banner.stripe_downleft.purple": "Barre de mûre",
  "block.minecraft.banner.stripe_downleft.red": "Barre de gueules",
  "block.minecraft.banner.stripe_downleft.white": "Barre d'argent",
  "block.minecraft.banner.stripe_downleft.yellow": "Barre d'or",
  "block.minecraft.banner.stripe_downright.black": "Bande de sable",
  "block.minecraft.banner.stripe_downright.blue": "Bande d'azur",
  "block.minecraft.banner.stripe_downright.brown": "Bande de tanné",
  "block.minecraft.banner.stripe_downright.cyan": "Bande de cyan",
  "block.minecraft.banner.stripe_downright.gray": "Bande d'acier",
  "block.minecraft.banner.stripe_downright.green": "Bande de sinople",
  "block.minecraft.banner.stripe_downright.light_blue": "Bande de bleu céleste",
  "block.minecraft.banner.stripe_downright.light_gray": "Bande d'argent grisé",
  "block.minecraft.banner.stripe_downright.lime": "Bande de sinople clair",
  "block.minecraft.banner.stripe_downright.magenta": "Bande de pourpre",
  "block.minecraft.banner.stripe_downright.orange": "Bande d'orangé",
  "block.minecraft.banner.stripe_downright.pink": "Bande de carnation",
  "block.minecraft.banner.stripe_downright.purple": "Bande de mûre",
  "block.minecraft.banner.stripe_downright.red": "Bande de gueules",
  "block.minecraft.banner.stripe_downright.white": "Bande d'argent",
  "block.minecraft.banner.stripe_downright.yellow": "Bande d'or",
  "block.minecraft.banner.stripe_left.black": "Flanc dextre de sable",
  "block.minecraft.banner.stripe_left.blue": "Flanc dextre d'azur",
  "block.minecraft.banner.stripe_left.brown": "Flanc dextre de tanné",
  "block.minecraft.banner.stripe_left.cyan": "Flanc dextre de cyan",
  "block.minecraft.banner.stripe_left.gray": "Flanc dextre d'acier",
  "block.minecraft.banner.stripe_left.green": "Flanc dextre de sinople",
  "block.minecraft.banner.stripe_left.light_blue": "Flanc dextre de bleu céleste",
  "block.minecraft.banner.stripe_left.light_gray": "Flanc dextre d'argent grisé",
  "block.minecraft.banner.stripe_left.lime": "Flanc dextre de sinople clair",
  "block.minecraft.banner.stripe_left.magenta": "Flanc dextre de pourpre",
  "block.minecraft.banner.stripe_left.orange": "Flanc dextre d'orangé",
  "block.minecraft.banner.stripe_left.pink": "Flanc dextre de carnation",
  "block.minecraft.banner.stripe_left.purple": "Flanc dextre de mûre",
  "block.minecraft.banner.stripe_left.red": "Flanc dextre de gueules",
  "block.minecraft.banner.stripe_left.white": "Flanc dextre d'argent",
  "block.minecraft.banner.stripe_left.yellow": "Flanc dextre d'or",
  "block.minecraft.banner.stripe_middle.black": "Fasce de sable",
  "block.minecraft.banner.stripe_middle.blue": "Fasce d'azur",
  "block.minecraft.banner.stripe_middle.brown": "Fasce de tanné",
  "block.minecraft.banner.stripe_middle.cyan": "Fasce de cyan",
  "block.minecraft.banner.stripe_middle.gray": "Fasce d'acier",
  "block.minecraft.banner.stripe_middle.green": "Fasce de sinople",
  "block.minecraft.banner.stripe_middle.light_blue": "Fasce de bleu céleste",
  "block.minecraft.banner.stripe_middle.light_gray": "Fasce d'argent grisé",
  "block.minecraft.banner.stripe_middle.lime": "Fasce de sinople clair",
  "block.minecraft.banner.stripe_middle.magenta": "Fasce de pourpre",
  "block.minecraft.banner.stripe_middle.orange": "Fasce d'orangé",
  "block.minecraft.banner.stripe_middle.pink": "Fasce de carnation",
  "block.minecraft.banner.stripe_middle.purple": "Fasce de mûre",
  "block.minecraft.banner.stripe_middle.red": "Fasce de gueules",
  "block.minecraft.banner.stripe_middle.white": "Fasce d'argent",
  "block.minecraft.banner.stripe_middle.yellow": "Fasce d'or",
  "block.minecraft.banner.stripe_right.black": "Flanc senestre de sable",
  "block.minecraft.banner.stripe_right.blue": "Flanc senestre d'azur",
  "block.minecraft.banner.stripe_right.brown": "Flanc senestre de tanné",
  "block.minecraft.banner.stripe_right.cyan": "Flanc senestre de cyan",
  "block.minecraft.banner.stripe_right.gray": "Flanc senestre d'acier",
  "block.minecraft.banner.stripe_right.green": "Flanc senestre de sinople",
  "block.minecraft.banner.stripe_right.light_blue": "Flanc senestre de bleu céleste",
  "block.minecraft.banner.stripe_right.light_gray": "Flanc senestre d'argent grisé",
  "block.minecraft.banner.stripe_right.lime": "Flanc senestre de sinople clair",
  "block.minecraft.banner.stripe_right.magenta": "Flanc senestre de pourpre",
  "block.minecraft.banner.stripe_right.orange": "Flanc senestre d'orangé",
  "block.minecraft.banner.stripe_right.pink": "Flanc senestre de carnation",
  "block.minecraft.banner.stripe_right.purple": "Flanc senestre de mûre",
  "block.minecraft.banner.stripe_right.red": "Flanc senestre de gueules",
  "block.minecraft.banner.stripe_right.white": "Flanc senestre d'argent",
  "block.minecraft.banner.stripe_right.yellow": "Flanc senestre d'or",
  "block.minecraft.banner.stripe_top.black": "Chef de sable",
  "block.minecraft.banner.stripe_top.blue": "Chef d'azur",
  "block.minecraft.banner.stripe_top.brown": "Chef de tanné",
  "block.minecraft.banner.stripe_top.cyan": "Chef de cyan",
  "block.minecraft.banner.stripe_top.gray": "Chef d'acier",
  "block.minecraft.banner.stripe_top.green": "Chef de sinople",
  "block.minecraft.banner.stripe_top.light_blue": "Chef de bleu céleste",
  "block.minecraft.banner.stripe_top.light_gray": "Chef d'argent grisé",
  "block.minecraft.banner.stripe_top.lime": "Chef de sinople clair",
  "block.minecraft.banner.stripe_top.magenta": "Chef de pourpre",
  "block.minecraft.banner.stripe_top.orange": "Chef d'orangé",
  "block.minecraft.banner.stripe_top.pink": "Chef de carnation",
  "block.minecraft.banner.stripe_top.purple": "Chef de mûre",
  "block.minecraft.banner.stripe_top.red": "Chef de gueules",
  "block.minecraft.banner.stripe_top.white": "Chef d'argent",
  "block.minecraft.banner.stripe_top.yellow": "Chef d'or",
  "block.minecraft.banner.triangle_bottom.black": "Mantelé de sable",
  "block.minecraft.banner.triangle_bottom.blue": "Mantelé d'azur",
  "block.minecraft.banner.triangle_bottom.brown": "Mantelé de tanné",
  "block.minecraft.banner.triangle_bottom.cyan": "Mantelé de cyan",
  "block.minecraft.banner.triangle_bottom.gray": "Mantelé d'acier",
  "block.minecraft.banner.triangle_bottom.green": "Mantelé de sinople",
  "block.minecraft.banner.triangle_bottom.light_blue": "Mantelé de bleu céleste",
  "block.minecraft.banner.triangle_bottom.light_gray": "Mantelé d'argent grisé",
  "block.minecraft.banner.triangle_bottom.lime": "Mantelé de sinople clair",
  "block.minecraft.banner.triangle_bottom.magenta": "Mantelé de pourpre",
  "block.minecraft.banner.triangle_bottom.orange": "Mantelé d'orangé",
  "block.minecraft.banner.triangle_bottom.pink": "Mantelé de carnation",
  "block.minecraft.banner.triangle_bottom.purple": "Mantelé de mûre",
  "block.minecraft.banner.triangle_bottom.red": "Mantelé de gueules",
  "block.minecraft.banner.triangle_bottom.white": "Mantelé d'argent",
  "block.minecraft.banner.triangle_bottom.yellow": "Mantelé d'or",
  "block.minecraft.banner.triangle_top.black": "Mantelé renversé de sable",
  "block.minecraft.banner.triangle_top.blue": "Mantelé renversé d'azur",
  "block.minecraft.banner.triangle_top.brown": "Mantelé renversé de tanné",
  "block.minecraft.banner.triangle_top.cyan": "Mantelé renversé de cyan",
  "block.minecraft.banner.triangle_top.gray": "Mantelé renversé d'acier",
  "block.minecraft.banner.triangle_top.green": "Mantelé renversé de sinople",
  "block.minecraft.banner.triangle_top.light_blue": "Mantelé renversé de bleu céleste",
  "block.minecraft.banner.triangle_top.light_gray": "Mantelé renversé d'argent grisé",
  "block.minecraft.banner.triangle_top.lime": "Mantelé renversé de sinople clair",
  "block.minecraft.banner.triangle_top.magenta": "Mantelé renversé de pourpre",
  "block.minecraft.banner.triangle_top.orange": "Mantelé renversé d'orangé",
  "block.minecraft.banner.triangle_top.pink": "Mantelé renversé de carnation",
  "block.minecraft.banner.triangle_top.purple": "Mantelé renversé de mûre",
  "block.minecraft.banner.triangle_top.red": "Mantelé renversé de gueules",
  "block.minecraft.banner.triangle_top.white": "Mantelé renversé d'argent",
  "block.minecraft.banner.triangle_top.yellow": "Mantelé renversé d'or",
  "block.minecraft.banner.triangles_bottom.black": "Émanchures noires mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.blue": "Émanchures bleues mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.brown": "Émanchures brunes mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.cyan": "Émanchures de cyan mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.gray": "Émanchures grises mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.green": "Émanchures vertes mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.light_blue": "Émanchures de bleu céleste mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.light_gray": "Émanchures d'argent grisé mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.lime": "Émanchures de sinople clair mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.magenta": "Émanchures de pourpre mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.orange": "Émanchures d'orangé mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.pink": "Émanchures carnations mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.purple": "Émanchures mauves mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.red": "Émanchures rouges mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.white": "Émanchures blanches mouvant de la pointe",
  "block.minecraft.banner.triangles_bottom.yellow": "Émanchures jaunes mouvant de la pointe",
  "block.minecraft.banner.triangles_top.black": "Émanchures noires mouvant du chef",
  "block.minecraft.banner.triangles_top.blue": "Émanchures bleues mouvant du chef",
  "block.minecraft.banner.triangles_top.brown": "Émanchures brunes mouvant du chef",
  "block.minecraft.banner.triangles_top.cyan": "Émanchures de cyan mouvant du chef",
  "block.minecraft.banner.triangles_top.gray": "Émanchures grises mouvant du chef",
  "block.minecraft.banner.triangles_top.green": "Émanchures vertes mouvant du chef",
  "block.minecraft.banner.triangles_top.light_blue": "Émanchures de bleu céleste mouvant du chef",
  "block.minecraft.banner.triangles_top.light_gray": "Émanchures d'argent grisé mouvant du chef",
  "block.minecraft.banner.triangles_top.lime": "Émanchures de sinople clair mouvant du chef",
  "block.minecraft.banner.triangles_top.magenta": "Émanchures de pourpre mouvant du chef",
  "block.minecraft.banner.triangles_top.orange": "Émanchures d'orangé mouvant du chef",
  "block.minecraft.banner.triangles_top.pink": "Émanchures carnations mouvant du chef",
  "block.minecraft.banner.triangles_top.purple": "Émanchures mauves mouvant du chef",
  "block.minecraft.banner.triangles_top.red": "Émanchures rouges mouvant du chef",
  "block.minecraft.banner.triangles_top.white": "Émanchures blanches mouvant du chef",
  "block.minecraft.banner.triangles_top.yellow": "Émanchures jaunes mouvant du chef",
  "block.minecraft.barrel": "Tonneau",
  "block.minecraft.barrier": "Barrière invisible",
  "block.minecraft.basalt": "Basalte",
  "block.minecraft.beacon": "Balise",
  "block.minecraft.beacon.primary": "Pouvoir primaire",
  "block.minecraft.beacon.secondary": "Pouvoir secondaire",
  "block.minecraft.bed.no_sleep": "Vous ne pouvez dormir que la nuit ou durant les orages",
  "block.minecraft.bed.not_safe": "Impossible de dormir; il y a des monstres tout près",
  "block.minecraft.bed.obstructed": "Ce lit est obstrué",
  "block.minecraft.bed.occupied": "Ce lit est occupé",
  "block.minecraft.bed.too_far_away": "Impossible de dormir; le lit est trop loin",
  "block.minecraft.bedrock": "Bedrock",
  "block.minecraft.bee_nest": "Nid d'abeilles",
  "block.minecraft.beehive": "Ruche",
  "block.minecraft.beetroots": "Betteraves",
  "block.minecraft.bell": "Cloche",
  "block.minecraft.big_dripleaf": "Grosse platefeuille",
  "block.minecraft.big_dripleaf_stem": "Tige de grosse platefeuille",
  "block.minecraft.birch_button": "Bouton en bouleau",
  "block.minecraft.birch_door": "Porte en bouleau",
  "block.minecraft.birch_fence": "Clôture en bouleau",
  "block.minecraft.birch_fence_gate": "Porte de clôture en bouleau",
  "block.minecraft.birch_hanging_sign": "Pancarte suspendue en bouleau",
  "block.minecraft.birch_leaves": "Feuilles de bouleau",
  "block.minecraft.birch_log": "Bûche de bouleau",
  "block.minecraft.birch_planks": "Planches de bouleau",
  "block.minecraft.birch_pressure_plate": "Plaque de pression en bouleau",
  "block.minecraft.birch_sapling": "Pousse de bouleau",
  "block.minecraft.birch_shelf": "Étagère en bouleau",
  "block.minecraft.birch_sign": "Pancarte en bouleau",
  "block.minecraft.birch_slab": "Dalle en bouleau",
  "block.minecraft.birch_stairs": "Escaliers en bouleau",
  "block.minecraft.birch_trapdoor": "Trappe en bouleau",
  "block.minecraft.birch_wall_hanging_sign": "Pancarte suspendue murale en bouleau",
  "block.minecraft.birch_wall_sign": "Pancarte murale en bouleau",
  "block.minecraft.birch_wood": "Bois de bouleau",
  "block.minecraft.black_banner": "Bannière de sable",
  "block.minecraft.black_bed": "Lit noir",
  "block.minecraft.black_candle": "Bougie noire",
  "block.minecraft.black_candle_cake": "Gâteau avec bougie noire",
  "block.minecraft.black_carpet": "Tapis noir",
  "block.minecraft.black_concrete": "Béton noir",
  "block.minecraft.black_concrete_powder": "Béton noir en poudre",
  "block.minecraft.black_glazed_terracotta": "Terracotta émaillée noire",
  "block.minecraft.black_shulker_box": "Boîte de Shulker noire",
  "block.minecraft.black_stained_glass": "Verre noir",
  "block.minecraft.black_stained_glass_pane": "Vitre noire",
  "block.minecraft.black_terracotta": "Terracotta noire",
  "block.minecraft.black_wool": "Laine noire",
  "block.minecraft.blackstone": "Blackstone",
  "block.minecraft.blackstone_slab": "Dalle de blackstone",
  "block.minecraft.blackstone_stairs": "Escaliers de blackstone",
  "block.minecraft.blackstone_wall": "Muret de blackstone",
  "block.minecraft.blast_furnace": "Haut fourneau",
  "block.minecraft.blue_banner": "Bannière d'azur",
  "block.minecraft.blue_bed": "Lit bleu",
  "block.minecraft.blue_candle": "Bougie bleue",
  "block.minecraft.blue_candle_cake": "Gâteau avec bougie bleue",
  "block.minecraft.blue_carpet": "Tapis bleu",
  "block.minecraft.blue_concrete": "Béton bleu",
  "block.minecraft.blue_concrete_powder": "Béton bleu en poudre",
  "block.minecraft.blue_glazed_terracotta": "Terracotta émaillée bleue",
  "block.minecraft.blue_ice": "Glace bleue",
  "block.minecraft.blue_orchid": "Orchidées bleues",
  "block.minecraft.blue_shulker_box": "Boîte de Shulker bleue",
  "block.minecraft.blue_stained_glass": "Verre bleu",
  "block.minecraft.blue_stained_glass_pane": "Vitre bleue",
  "block.minecraft.blue_terracotta": "Terracotta bleue",
  "block.minecraft.blue_wool": "Laine bleue",
  "block.minecraft.bone_block": "Bloc d'os",
  "block.minecraft.bookshelf": "Bibliothèque",
  "block.minecraft.brain_coral": "Corail cerveau",
  "block.minecraft.brain_coral_block": "Bloc de corail cerveau",
  "block.minecraft.brain_coral_fan": "Gorgone de corail cerveau",
  "block.minecraft.brain_coral_wall_fan": "Gorgone de corail cerveau murale",
  "block.minecraft.brewing_stand": "Stand d'alchimie",
  "block.minecraft.brick_slab": "Dalle de briques",
  "block.minecraft.brick_stairs": "Escaliers de briques",
  "block.minecraft.brick_wall": "Muret de briques",
  "block.minecraft.bricks": "Briques",
  "block.minecraft.brown_banner": "Bannière de tanné",
  "block.minecraft.brown_bed": "Lit brun",
  "block.minecraft.brown_candle": "Bougie brune",
  "block.minecraft.brown_candle_cake": "Gâteau avec bougie brune",
  "block.minecraft.brown_carpet": "Tapis brun",
  "block.minecraft.brown_concrete": "Béton brun",
  "block.minecraft.brown_concrete_powder": "Béton brun en poudre",
  "block.minecraft.brown_glazed_terracotta": "Terracotta émaillée brune",
  "block.minecraft.brown_mushroom": "Champignon brun",
  "block.minecraft.brown_mushroom_block": "Bloc de champignon brun",
  "block.minecraft.brown_shulker_box": "Boîte de Shulker brune",
  "block.minecraft.brown_stained_glass": "Verre brun",
  "block.minecraft.brown_stained_glass_pane": "Vitre brune",
  "block.minecraft.brown_terracotta": "Terracotta brune",
  "block.minecraft.brown_wool": "Laine brune",
  "block.minecraft.bubble_column": "Colonne de bulles",
  "block.minecraft.bubble_coral": "Corail bulle",
  "block.minecraft.bubble_coral_block": "Bloc de corail bulle",
  "block.minecraft.bubble_coral_fan": "Gorgone de corail bulle",
  "block.minecraft.bubble_coral_wall_fan": "Gorgone de corail bulle murale",
  "block.minecraft.budding_amethyst": "Bloc d'améthyste bourgeonnante",
  "block.minecraft.bush": "Buisson",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Fleur de cactus",
  "block.minecraft.cake": "Gâteau",
  "block.minecraft.calcite": "Calcite",
  "block.minecraft.calibrated_sculk_sensor": "Capteur sculk calibré",
  "block.minecraft.campfire": "Feu de camp",
  "block.minecraft.candle": "Bougie",
  "block.minecraft.candle_cake": "Gâteau avec bougie",
  "block.minecraft.carrots": "Carottes",
  "block.minecraft.cartography_table": "Table de cartographie",
  "block.minecraft.carved_pumpkin": "Citrouille sculptée",
  "block.minecraft.cauldron": "Chaudron",
  "block.minecraft.cave_air": "Air des cavernes",
  "block.minecraft.cave_vines": "Lianes des cavernes",
  "block.minecraft.cave_vines_plant": "Plante de lianes des cavernes",
  "block.minecraft.chain": "Chaîne",
  "block.minecraft.chain_command_block": "Bloc de commande en chaîne",
  "block.minecraft.cherry_button": "Bouton en cerisier",
  "block.minecraft.cherry_door": "Porte en cerisier",
  "block.minecraft.cherry_fence": "Clôture en cerisier",
  "block.minecraft.cherry_fence_gate": "Porte de clôture en cerisier",
  "block.minecraft.cherry_hanging_sign": "Pancarte suspendue en cerisier",
  "block.minecraft.cherry_leaves": "Feuilles de cerisier",
  "block.minecraft.cherry_log": "Bûche de cerisier",
  "block.minecraft.cherry_planks": "Planches de cerisier",
  "block.minecraft.cherry_pressure_plate": "Plaque de pression en cerisier",
  "block.minecraft.cherry_sapling": "Pousse de cerisier",
  "block.minecraft.cherry_shelf": "Étagère en cerisier",
  "block.minecraft.cherry_sign": "Pancarte en cerisier",
  "block.minecraft.cherry_slab": "Dalle en cerisier",
  "block.minecraft.cherry_stairs": "Escaliers en cerisier",
  "block.minecraft.cherry_trapdoor": "Trappe en cerisier",
  "block.minecraft.cherry_wall_hanging_sign": "Pancarte suspendue murale en cerisier",
  "block.minecraft.cherry_wall_sign": "Pancarte murale en cerisier",
  "block.minecraft.cherry_wood": "Bois de cerisier",
  "block.minecraft.chest": "Coffre",
  "block.minecraft.chipped_anvil": "Enclume ébréchée",
  "block.minecraft.chiseled_bookshelf": "Bibliothèque sculptée",
  "block.minecraft.chiseled_copper": "Cuivre ciselé",
  "block.minecraft.chiseled_deepslate": "Profondoise ciselée",
  "block.minecraft.chiseled_nether_bricks": "Briques du Nether ciselées",
  "block.minecraft.chiseled_polished_blackstone": "Blackstone polie ciselée",
  "block.minecraft.chiseled_quartz_block": "Quartz ciselé",
  "block.minecraft.chiseled_red_sandstone": "Grès rouge ciselé",
  "block.minecraft.chiseled_resin_bricks": "Briques de résine ciselées",
  "block.minecraft.chiseled_sandstone": "Grès ciselé",
  "block.minecraft.chiseled_stone_bricks": "Briques de pierre ciselées",
  "block.minecraft.chiseled_tuff": "Tuf ciselé",
  "block.minecraft.chiseled_tuff_bricks": "Briques de tuf ciselées",
  "block.minecraft.chorus_flower": "Fleur de chorus",
  "block.minecraft.chorus_plant": "Plante de chorus",
  "block.minecraft.clay": "Glaise",
  "block.minecraft.closed_eyeblossom": "Oeillet fermé",
  "block.minecraft.coal_block": "Bloc de charbon",
  "block.minecraft.coal_ore": "Minerai de charbon",
  "block.minecraft.coarse_dirt": "Terre stérile",
  "block.minecraft.cobbled_deepslate": "Profondoise concassée",
  "block.minecraft.cobbled_deepslate_slab": "Dalle de profondoise concassée",
  "block.minecraft.cobbled_deepslate_stairs": "Escaliers de profondoise concassée",
  "block.minecraft.cobbled_deepslate_wall": "Muret de profondoise concassée",
  "block.minecraft.cobblestone": "Cobblestone",
  "block.minecraft.cobblestone_slab": "Dalle de cobblestone",
  "block.minecraft.cobblestone_stairs": "Escaliers de cobblestone",
  "block.minecraft.cobblestone_wall": "Muret de cobblestone",
  "block.minecraft.cobweb": "Toile d'araignée",
  "block.minecraft.cocoa": "Cabosse",
  "block.minecraft.command_block": "Bloc de commande",
  "block.minecraft.comparator": "Comparateur de redstone",
  "block.minecraft.composter": "Composteur",
  "block.minecraft.conduit": "Conduit",
  "block.minecraft.copper_bars": "Barreaux de cuivre",
  "block.minecraft.copper_block": "Bloc de cuivre",
  "block.minecraft.copper_bulb": "Lampe en cuivre",
  "block.minecraft.copper_chain": "Chaîne en cuivre",
  "block.minecraft.copper_chest": "Coffre en cuivre",
  "block.minecraft.copper_door": "Porte en cuivre",
  "block.minecraft.copper_golem_statue": "Statue de golem de cuivre",
  "block.minecraft.copper_grate": "Grille en cuivre",
  "block.minecraft.copper_lantern": "Lanterne en cuivre",
  "block.minecraft.copper_ore": "Minerai de cuivre",
  "block.minecraft.copper_torch": "Torche de cuivre",
  "block.minecraft.copper_trapdoor": "Trappe en cuivre",
  "block.minecraft.copper_wall_torch": "Torche de cuivre murale",
  "block.minecraft.cornflower": "Centaurée bleuet",
  "block.minecraft.cracked_deepslate_bricks": "Briques de profondoise craquelées",
  "block.minecraft.cracked_deepslate_tiles": "Tuiles de profondoise craquelées",
  "block.minecraft.cracked_nether_bricks": "Briques du Nether craquelées",
  "block.minecraft.cracked_polished_blackstone_bricks": "Briques de blackstone polie craquelées",
  "block.minecraft.cracked_stone_bricks": "Briques de pierre craquelées",
  "block.minecraft.crafter": "Crafteur",
  "block.minecraft.crafting_table": "Établi",
  "block.minecraft.creaking_heart": "Coeur de grinceur",
  "block.minecraft.creeper_head": "Tête de Creeper",
  "block.minecraft.creeper_wall_head": "Tête de Creeper murale",
  "block.minecraft.crimson_button": "Bouton cramoisi",
  "block.minecraft.crimson_door": "Porte cramoisie",
  "block.minecraft.crimson_fence": "Clôture cramoisie",
  "block.minecraft.crimson_fence_gate": "Porte de clôture cramoisie",
  "block.minecraft.crimson_fungus": "Champignon cramoisi",
  "block.minecraft.crimson_hanging_sign": "Pancarte suspendue cramoisie",
  "block.minecraft.crimson_hyphae": "Hyphes cramoisies",
  "block.minecraft.crimson_nylium": "Nylium cramoisi",
  "block.minecraft.crimson_planks": "Planches cramoisies",
  "block.minecraft.crimson_pressure_plate": "Plaque de pression cramoisie",
  "block.minecraft.crimson_roots": "Racines cramoisies",
  "block.minecraft.crimson_shelf": "Étagère cramoisie",
  "block.minecraft.crimson_sign": "Pancarte cramoisie",
  "block.minecraft.crimson_slab": "Dalle cramoisie",
  "block.minecraft.crimson_stairs": "Escaliers cramoisis",
  "block.minecraft.crimson_stem": "Tige cramoisie",
  "block.minecraft.crimson_trapdoor": "Trappe cramoisie",
  "block.minecraft.crimson_wall_hanging_sign": "Pancarte suspendue murale cramoisie",
  "block.minecraft.crimson_wall_sign": "Pancarte murale cramoisie",
  "block.minecraft.crying_obsidian": "Obsidienne pleureuse",
  "block.minecraft.cut_copper": "Cuivre taillé",
  "block.minecraft.cut_copper_slab": "Dalle de cuivre taillé",
  "block.minecraft.cut_copper_stairs": "Escaliers de cuivre taillé",
  "block.minecraft.cut_red_sandstone": "Grès rouge taillé",
  "block.minecraft.cut_red_sandstone_slab": "Dalle de grès rouge taillé",
  "block.minecraft.cut_sandstone": "Grès taillé",
  "block.minecraft.cut_sandstone_slab": "Dalle de grès taillé",
  "block.minecraft.cyan_banner": "Bannière de cyan",
  "block.minecraft.cyan_bed": "Lit cyan",
  "block.minecraft.cyan_candle": "Bougie cyan",
  "block.minecraft.cyan_candle_cake": "Gâteau avec bougie cyan",
  "block.minecraft.cyan_carpet": "Tapis cyan",
  "block.minecraft.cyan_concrete": "Béton cyan",
  "block.minecraft.cyan_concrete_powder": "Béton cyan en poudre",
  "block.minecraft.cyan_glazed_terracotta": "Terracotta émaillée cyan",
  "block.minecraft.cyan_shulker_box": "Boîte de Shulker cyan",
  "block.minecraft.cyan_stained_glass": "Verre cyan",
  "block.minecraft.cyan_stained_glass_pane": "Vitre cyan",
  "block.minecraft.cyan_terracotta": "Terracotta cyan",
  "block.minecraft.cyan_wool": "Laine cyan",
  "block.minecraft.damaged_anvil": "Enclume endommagée",
  "block.minecraft.dandelion": "Pissenlit",
  "block.minecraft.dark_oak_button": "Bouton en chêne noir",
  "block.minecraft.dark_oak_door": "Porte en chêne noir",
  "block.minecraft.dark_oak_fence": "Clôture en chêne noir",
  "block.minecraft.dark_oak_fence_gate": "Porte de clôture en chêne noir",
  "block.minecraft.dark_oak_hanging_sign": "Pancarte suspendue en chêne noir",
  "block.minecraft.dark_oak_leaves": "Feuilles de chêne noir",
  "block.minecraft.dark_oak_log": "Bûche de chêne noir",
  "block.minecraft.dark_oak_planks": "Planches de chêne noir",
  "block.minecraft.dark_oak_pressure_plate": "Plaque de pression en chêne noir",
  "block.minecraft.dark_oak_sapling": "Pousse de chêne noir",
  "block.minecraft.dark_oak_shelf": "Étagère en chêne noir",
  "block.minecraft.dark_oak_sign": "Pancarte en chêne noir",
  "block.minecraft.dark_oak_slab": "Dalle en chêne noir",
  "block.minecraft.dark_oak_stairs": "Escaliers en chêne noir",
  "block.minecraft.dark_oak_trapdoor": "Trappe en chêne noir",
  "block.minecraft.dark_oak_wall_hanging_sign": "Pancarte suspendue murale en chêne noir",
  "block.minecraft.dark_oak_wall_sign": "Pancarte murale en chêne noir",
  "block.minecraft.dark_oak_wood": "Bois de chêne noir",
  "block.minecraft.dark_prismarine": "Prismarine sombre",
  "block.minecraft.dark_prismarine_slab": "Dalle de prismarine sombre",
  "block.minecraft.dark_prismarine_stairs": "Escaliers de prismarine sombre",
  "block.minecraft.daylight_detector": "Détecteur solaire",
  "block.minecraft.dead_brain_coral": "Corail cerveau mort",
  "block.minecraft.dead_brain_coral_block": "Bloc de corail cerveau mort",
  "block.minecraft.dead_brain_coral_fan": "Gorgone de corail cerveau morte",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgone de corail cerveau murale morte",
  "block.minecraft.dead_bubble_coral": "Corail bulle mort",
  "block.minecraft.dead_bubble_coral_block": "Bloc de corail bulle mort",
  "block.minecraft.dead_bubble_coral_fan": "Gorgone de corail bulle morte",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgone de corail bulle murale morte",
  "block.minecraft.dead_bush": "Buisson mort",
  "block.minecraft.dead_fire_coral": "Corail de feu mort",
  "block.minecraft.dead_fire_coral_block": "Bloc de corail de feu mort",
  "block.minecraft.dead_fire_coral_fan": "Gorgone de corail de feu morte",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgone de corail de feu murale morte",
  "block.minecraft.dead_horn_coral": "Corail corné mort",
  "block.minecraft.dead_horn_coral_block": "Bloc de corail corné mort",
  "block.minecraft.dead_horn_coral_fan": "Gorgone de corail corné morte",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgone de corail corné murale morte",
  "block.minecraft.dead_tube_coral": "Corail tube mort",
  "block.minecraft.dead_tube_coral_block": "Bloc de corail tube mort",
  "block.minecraft.dead_tube_coral_fan": "Gorgone de corail tube morte",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgone de corail tube murale morte",
  "block.minecraft.decorated_pot": "Pot décoré",
  "block.minecraft.deepslate": "Profondoise",
  "block.minecraft.deepslate_brick_slab": "Dalle de briques de profondoise",
  "block.minecraft.deepslate_brick_stairs": "Escaliers de briques de profondoise",
  "block.minecraft.deepslate_brick_wall": "Muret de briques de profondoise",
  "block.minecraft.deepslate_bricks": "Briques de profondoise",
  "block.minecraft.deepslate_coal_ore": "Minerai de charbon de profondoise",
  "block.minecraft.deepslate_copper_ore": "Minerai de cuivre de profondoise",
  "block.minecraft.deepslate_diamond_ore": "Minerai de diamant de profondoise",
  "block.minecraft.deepslate_emerald_ore": "Minerai d'émeraude de profondoise",
  "block.minecraft.deepslate_gold_ore": "Minerai d'or de profondoise",
  "block.minecraft.deepslate_iron_ore": "Minerai de fer de profondoise",
  "block.minecraft.deepslate_lapis_ore": "Minerai de lapis-lazuli de profondoise",
  "block.minecraft.deepslate_redstone_ore": "Minerai de redstone de profondoise",
  "block.minecraft.deepslate_tile_slab": "Dalle de tuiles de profondoise",
  "block.minecraft.deepslate_tile_stairs": "Escaliers de tuiles de profondoise",
  "block.minecraft.deepslate_tile_wall": "Muret de tuiles de profondoise",
  "block.minecraft.deepslate_tiles": "Tuiles de profondoise",
  "block.minecraft.detector_rail": "Rails détecteurs",
  "block.minecraft.diamond_block": "Bloc de diamant",
  "block.minecraft.diamond_ore": "Minerai de diamant",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Dalle de diorite",
  "block.minecraft.diorite_stairs": "Escaliers de diorite",
  "block.minecraft.diorite_wall": "Muret de diorite",
  "block.minecraft.dirt": "Terre",
  "block.minecraft.dirt_path": "Chemin de terre",
  "block.minecraft.dispenser": "Distributeur",
  "block.minecraft.dragon_egg": "Oeuf de dragon",
  "block.minecraft.dragon_head": "Tête de dragon",
  "block.minecraft.dragon_wall_head": "Tête de dragon murale",
  "block.minecraft.dried_ghast": "Ghast desséché",
  "block.minecraft.dried_kelp_block": "Bloc de kelp séché",
  "block.minecraft.dripstone_block": "Bloc de spéléothème",
  "block.minecraft.dropper": "Droppeur",
  "block.minecraft.emerald_block": "Bloc d'émeraude",
  "block.minecraft.emerald_ore": "Minerai d'émeraude",
  "block.minecraft.enchanting_table": "Table d'enchantement",
  "block.minecraft.end_gateway": "Passerelle de l'End",
  "block.minecraft.end_portal": "Portail de l'End",
  "block.minecraft.end_portal_frame": "Cadre de portail de l'End",
  "block.minecraft.end_rod": "Barre de l'End",
  "block.minecraft.end_stone": "Roche de l'End",
  "block.minecraft.end_stone_brick_slab": "Dalle de briques de pierre de l'End",
  "block.minecraft.end_stone_brick_stairs": "Escaliers de briques de pierre de l'End",
  "block.minecraft.end_stone_brick_wall": "Muret de briques de pierre de l'End",
  "block.minecraft.end_stone_bricks": "Briques de pierre de l'End",
  "block.minecraft.ender_chest": "Ender coffre",
  "block.minecraft.exposed_chiseled_copper": "Cuivre ciselé exposé",
  "block.minecraft.exposed_copper": "Bloc de cuivre exposé",
  "block.minecraft.exposed_copper_bars": "Barreaux de cuivre exposé",
  "block.minecraft.exposed_copper_bulb": "Lampe en cuivre exposé",
  "block.minecraft.exposed_copper_chain": "Chaîne en cuivre exposé",
  "block.minecraft.exposed_copper_chest": "Coffre en cuivre exposé",
  "block.minecraft.exposed_copper_door": "Porte en cuivre exposé",
  "block.minecraft.exposed_copper_golem_statue": "Statue de golem de cuivre exposé",
  "block.minecraft.exposed_copper_grate": "Grille en cuivre exposé",
  "block.minecraft.exposed_copper_lantern": "Lanterne en cuivre exposé",
  "block.minecraft.exposed_copper_trapdoor": "Trappe en cuivre exposé",
  "block.minecraft.exposed_cut_copper": "Cuivre taillé exposé",
  "block.minecraft.exposed_cut_copper_slab": "Dalle de cuivre taillé exposé",
  "block.minecraft.exposed_cut_copper_stairs": "Escaliers de cuivre taillé exposé",
  "block.minecraft.exposed_lightning_rod": "Paratonnerre exposé",
  "block.minecraft.farmland": "Terre labourée",
  "block.minecraft.fern": "Fougère",
  "block.minecraft.fire": "Feu",
  "block.minecraft.fire_coral": "Corail de feu",
  "block.minecraft.fire_coral_block": "Bloc de corail de feu",
  "block.minecraft.fire_coral_fan": "Gorgone de corail de feu",
  "block.minecraft.fire_coral_wall_fan": "Gorgone de corail de feu murale",
  "block.minecraft.firefly_bush": "Buisson de mouches à feu",
  "block.minecraft.fletching_table": "Table d'archerie",
  "block.minecraft.flower_pot": "Pot de fleurs",
  "block.minecraft.flowering_azalea": "Azalée en fleurs",
  "block.minecraft.flowering_azalea_leaves": "Feuilles d'azalée en fleurs",
  "block.minecraft.frogspawn": "Oeufs de grenouille",
  "block.minecraft.frosted_ice": "Glace givrée",
  "block.minecraft.furnace": "Fourneau",
  "block.minecraft.gilded_blackstone": "Blackstone dorée",
  "block.minecraft.glass": "Verre",
  "block.minecraft.glass_pane": "Vitre",
  "block.minecraft.glow_lichen": "Lichen lumineux",
  "block.minecraft.glowstone": "Glowstone",
  "block.minecraft.gold_block": "Bloc d'or",
  "block.minecraft.gold_ore": "Minerai d'or",
  "block.minecraft.golden_dandelion": "Pissenlit doré",
  "block.minecraft.granite": "Granite",
  "block.minecraft.granite_slab": "Dalle de granite",
  "block.minecraft.granite_stairs": "Escaliers de granite",
  "block.minecraft.granite_wall": "Muret de granite",
  "block.minecraft.grass": "Herbe",
  "block.minecraft.grass_block": "Gazon",
  "block.minecraft.gravel": "Gravelle",
  "block.minecraft.gray_banner": "Bannière d'acier",
  "block.minecraft.gray_bed": "Lit gris",
  "block.minecraft.gray_candle": "Bougie grise",
  "block.minecraft.gray_candle_cake": "Gâteau avec bougie grise",
  "block.minecraft.gray_carpet": "Tapis gris",
  "block.minecraft.gray_concrete": "Béton gris",
  "block.minecraft.gray_concrete_powder": "Béton gris en poudre",
  "block.minecraft.gray_glazed_terracotta": "Terracotta émaillée grise",
  "block.minecraft.gray_shulker_box": "Boîte de Shulker grise",
  "block.minecraft.gray_stained_glass": "Verre gris",
  "block.minecraft.gray_stained_glass_pane": "Vitre grise",
  "block.minecraft.gray_terracotta": "Terracotta grise",
  "block.minecraft.gray_wool": "Laine grise",
  "block.minecraft.green_banner": "Bannière de sinople",
  "block.minecraft.green_bed": "Lit vert",
  "block.minecraft.green_candle": "Bougie verte",
  "block.minecraft.green_candle_cake": "Gâteau avec bougie verte",
  "block.minecraft.green_carpet": "Tapis vert",
  "block.minecraft.green_concrete": "Béton vert",
  "block.minecraft.green_concrete_powder": "Béton vert en poudre",
  "block.minecraft.green_glazed_terracotta": "Terracotta émaillée verte",
  "block.minecraft.green_shulker_box": "Boîte de Shulker verte",
  "block.minecraft.green_stained_glass": "Verre vert",
  "block.minecraft.green_stained_glass_pane": "Vitre verte",
  "block.minecraft.green_terracotta": "Terracotta verte",
  "block.minecraft.green_wool": "Laine verte",
  "block.minecraft.grindstone": "Meule",
  "block.minecraft.hanging_roots": "Racines suspendues",
  "block.minecraft.hay_block": "Botte de paille",
  "block.minecraft.heavy_core": "Noyau lourd",
  "block.minecraft.heavy_weighted_pressure_plate": "Plaque de lourde pesée",
  "block.minecraft.honey_block": "Bloc de miel",
  "block.minecraft.honeycomb_block": "Bloc de rayon de miel",
  "block.minecraft.hopper": "Entonnoir",
  "block.minecraft.horn_coral": "Corail corné",
  "block.minecraft.horn_coral_block": "Bloc de corail corné",
  "block.minecraft.horn_coral_fan": "Gorgone de corail corné",
  "block.minecraft.horn_coral_wall_fan": "Gorgone de corail corné murale",
  "block.minecraft.ice": "Glace",
  "block.minecraft.infested_chiseled_stone_bricks": "Briques de pierre ciselées infestées",
  "block.minecraft.infested_cobblestone": "Cobblestone infestée",
  "block.minecraft.infested_cracked_stone_bricks": "Briques de pierre craquelées infestées",
  "block.minecraft.infested_deepslate": "Profondoise infestée",
  "block.minecraft.infested_mossy_stone_bricks": "Briques de pierre moussues infestées",
  "block.minecraft.infested_stone": "Roche infestée",
  "block.minecraft.infested_stone_bricks": "Briques de pierre infestées",
  "block.minecraft.iron_bars": "Barreaux de fer",
  "block.minecraft.iron_block": "Bloc de fer",
  "block.minecraft.iron_chain": "Chaîne en fer",
  "block.minecraft.iron_door": "Porte en fer",
  "block.minecraft.iron_ore": "Minerai de fer",
  "block.minecraft.iron_trapdoor": "Trappe en fer",
  "block.minecraft.jack_o_lantern": "Citrouille d'Halloween",
  "block.minecraft.jigsaw": "Bloc casse-tête",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Bouton en acajou",
  "block.minecraft.jungle_door": "Porte en acajou",
  "block.minecraft.jungle_fence": "Clôture en acajou",
  "block.minecraft.jungle_fence_gate": "Porte de clôture en acajou",
  "block.minecraft.jungle_hanging_sign": "Pancarte suspendue en acajou",
  "block.minecraft.jungle_leaves": "Feuilles d'acajou",
  "block.minecraft.jungle_log": "Bûche d'acajou",
  "block.minecraft.jungle_planks": "Planches d'acajou",
  "block.minecraft.jungle_pressure_plate": "Plaque de pression en acajou",
  "block.minecraft.jungle_sapling": "Pousse d'acajou",
  "block.minecraft.jungle_shelf": "Étagère en acajou",
  "block.minecraft.jungle_sign": "Pancarte en acajou",
  "block.minecraft.jungle_slab": "Dalle en acajou",
  "block.minecraft.jungle_stairs": "Escaliers en acajou",
  "block.minecraft.jungle_trapdoor": "Trappe en acajou",
  "block.minecraft.jungle_wall_hanging_sign": "Pancarte suspendue murale en acajou",
  "block.minecraft.jungle_wall_sign": "Pancarte murale en acajou",
  "block.minecraft.jungle_wood": "Bois d'acajou",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Plante de kelp",
  "block.minecraft.ladder": "Échelle",
  "block.minecraft.lantern": "Lanterne",
  "block.minecraft.lapis_block": "Bloc de lapis-lazuli",
  "block.minecraft.lapis_ore": "Minerai de lapis-lazuli",
  "block.minecraft.large_amethyst_bud": "Grand bourgeon d'améthyste",
  "block.minecraft.large_fern": "Grande fougère",
  "block.minecraft.lava": "Lave",
  "block.minecraft.lava_cauldron": "Chaudron de lave",
  "block.minecraft.leaf_litter": "Feuilles mortes",
  "block.minecraft.lectern": "Lutrin",
  "block.minecraft.lever": "Levier",
  "block.minecraft.light": "Lumière",
  "block.minecraft.light_blue_banner": "Bannière de bleu céleste",
  "block.minecraft.light_blue_bed": "Lit bleu pâle",
  "block.minecraft.light_blue_candle": "Bougie bleu pâle",
  "block.minecraft.light_blue_candle_cake": "Gâteau avec bougie bleu pâle",
  "block.minecraft.light_blue_carpet": "Tapis bleu pâle",
  "block.minecraft.light_blue_concrete": "Béton bleu pâle",
  "block.minecraft.light_blue_concrete_powder": "Béton bleu pâle en poudre",
  "block.minecraft.light_blue_glazed_terracotta": "Terracotta émaillée bleu pâle",
  "block.minecraft.light_blue_shulker_box": "Boîte de Shulker bleu pâle",
  "block.minecraft.light_blue_stained_glass": "Verre bleu pâle",
  "block.minecraft.light_blue_stained_glass_pane": "Vitre bleu pâle",
  "block.minecraft.light_blue_terracotta": "Terracotta bleu pâle",
  "block.minecraft.light_blue_wool": "Laine bleu pâle",
  "block.minecraft.light_gray_banner": "Bannière d'argent grisé",
  "block.minecraft.light_gray_bed": "Lit gris pâle",
  "block.minecraft.light_gray_candle": "Bougie gris pâle",
  "block.minecraft.light_gray_candle_cake": "Gâteau avec bougie gris pâle",
  "block.minecraft.light_gray_carpet": "Tapis gris pâle",
  "block.minecraft.light_gray_concrete": "Béton gris pâle",
  "block.minecraft.light_gray_concrete_powder": "Béton gris pâle en poudre",
  "block.minecraft.light_gray_glazed_terracotta": "Terracotta émaillée gris pâle",
  "block.minecraft.light_gray_shulker_box": "Boîte de Shulker gris pâle",
  "block.minecraft.light_gray_stained_glass": "Verre gris pâle",
  "block.minecraft.light_gray_stained_glass_pane": "Vitre gris pâle",
  "block.minecraft.light_gray_terracotta": "Terracotta gris pâle",
  "block.minecraft.light_gray_wool": "Laine gris pâle",
  "block.minecraft.light_weighted_pressure_plate": "Plaque de légère pesée",
  "block.minecraft.lightning_rod": "Paratonnerre",
  "block.minecraft.lilac": "Lilas",
  "block.minecraft.lily_of_the_valley": "Muguet",
  "block.minecraft.lily_pad": "Nénuphar",
  "block.minecraft.lime_banner": "Bannière de sinople clair",
  "block.minecraft.lime_bed": "Lit vert lime",
  "block.minecraft.lime_candle": "Bougie vert lime",
  "block.minecraft.lime_candle_cake": "Gâteau avec bougie vert lime",
  "block.minecraft.lime_carpet": "Tapis vert lime",
  "block.minecraft.lime_concrete": "Béton vert lime",
  "block.minecraft.lime_concrete_powder": "Béton vert lime en poudre",
  "block.minecraft.lime_glazed_terracotta": "Terracotta émaillée vert lime",
  "block.minecraft.lime_shulker_box": "Boîte de Shulker vert lime",
  "block.minecraft.lime_stained_glass": "Verre vert lime",
  "block.minecraft.lime_stained_glass_pane": "Vitre vert lime",
  "block.minecraft.lime_terracotta": "Terracotta vert lime",
  "block.minecraft.lime_wool": "Laine vert lime",
  "block.minecraft.lodestone": "Magnétite",
  "block.minecraft.loom": "Métier à tisser",
  "block.minecraft.magenta_banner": "Bannière de pourpre",
  "block.minecraft.magenta_bed": "Lit magenta",
  "block.minecraft.magenta_candle": "Bougie magenta",
  "block.minecraft.magenta_candle_cake": "Gâteau avec bougie magenta",
  "block.minecraft.magenta_carpet": "Tapis magenta",
  "block.minecraft.magenta_concrete": "Béton magenta",
  "block.minecraft.magenta_concrete_powder": "Béton magenta en poudre",
  "block.minecraft.magenta_glazed_terracotta": "Terracotta émaillée magenta",
  "block.minecraft.magenta_shulker_box": "Boîte de Shulker magenta",
  "block.minecraft.magenta_stained_glass": "Verre magenta",
  "block.minecraft.magenta_stained_glass_pane": "Vitre magenta",
  "block.minecraft.magenta_terracotta": "Terracotta magenta",
  "block.minecraft.magenta_wool": "Laine magenta",
  "block.minecraft.magma_block": "Magma",
  "block.minecraft.mangrove_button": "Bouton en palétuvier",
  "block.minecraft.mangrove_door": "Porte en palétuvier",
  "block.minecraft.mangrove_fence": "Clôture en palétuvier",
  "block.minecraft.mangrove_fence_gate": "Porte de clôture en palétuvier",
  "block.minecraft.mangrove_hanging_sign": "Pancarte suspendue en palétuvier",
  "block.minecraft.mangrove_leaves": "Feuilles de palétuvier",
  "block.minecraft.mangrove_log": "Bûche de palétuvier",
  "block.minecraft.mangrove_planks": "Planches de palétuvier",
  "block.minecraft.mangrove_pressure_plate": "Plaque de pression en palétuvier",
  "block.minecraft.mangrove_propagule": "Propagule de palétuvier",
  "block.minecraft.mangrove_roots": "Racines de palétuvier",
  "block.minecraft.mangrove_shelf": "Étagère en palétuvier",
  "block.minecraft.mangrove_sign": "Pancarte en palétuvier",
  "block.minecraft.mangrove_slab": "Dalle en palétuvier",
  "block.minecraft.mangrove_stairs": "Escaliers en palétuvier",
  "block.minecraft.mangrove_trapdoor": "Trappe en palétuvier",
  "block.minecraft.mangrove_wall_hanging_sign": "Pancarte suspendue murale en palétuvier",
  "block.minecraft.mangrove_wall_sign": "Pancarte murale en palétuvier",
  "block.minecraft.mangrove_wood": "Bois de palétuvier",
  "block.minecraft.medium_amethyst_bud": "Moyen bourgeon d'améthyste",
  "block.minecraft.melon": "Melon d'eau",
  "block.minecraft.melon_stem": "Tige de melon d'eau",
  "block.minecraft.moss_block": "Bloc de mousse",
  "block.minecraft.moss_carpet": "Tapis de mousse",
  "block.minecraft.mossy_cobblestone": "Cobblestone moussue",
  "block.minecraft.mossy_cobblestone_slab": "Dalle de cobblestone moussue",
  "block.minecraft.mossy_cobblestone_stairs": "Escaliers de cobblestone moussue",
  "block.minecraft.mossy_cobblestone_wall": "Muret de cobblestone moussue",
  "block.minecraft.mossy_stone_brick_slab": "Dalle de briques de pierre moussues",
  "block.minecraft.mossy_stone_brick_stairs": "Escaliers de briques de pierre moussues",
  "block.minecraft.mossy_stone_brick_wall": "Muret de briques de pierre moussues",
  "block.minecraft.mossy_stone_bricks": "Briques de pierre moussues",
  "block.minecraft.moving_piston": "Bloc en mouvement",
  "block.minecraft.mud": "Bouette",
  "block.minecraft.mud_brick_slab": "Dalle de briques crues",
  "block.minecraft.mud_brick_stairs": "Escaliers de briques crues",
  "block.minecraft.mud_brick_wall": "Muret de briques crues",
  "block.minecraft.mud_bricks": "Briques crues",
  "block.minecraft.muddy_mangrove_roots": "Racines de palétuvier bouetteuses",
  "block.minecraft.mushroom_stem": "Tige de champignon",
  "block.minecraft.mycelium": "Mycélium",
  "block.minecraft.nether_brick_fence": "Clôture de briques du Nether",
  "block.minecraft.nether_brick_slab": "Dalle de briques du Nether",
  "block.minecraft.nether_brick_stairs": "Escaliers de briques du Nether",
  "block.minecraft.nether_brick_wall": "Muret de briques du Nether",
  "block.minecraft.nether_bricks": "Briques du Nether",
  "block.minecraft.nether_gold_ore": "Minerai d'or du Nether",
  "block.minecraft.nether_portal": "Portail du Nether",
  "block.minecraft.nether_quartz_ore": "Minerai de quartz du Nether",
  "block.minecraft.nether_sprouts": "Germes du Nether",
  "block.minecraft.nether_wart": "Verrues du Nether",
  "block.minecraft.nether_wart_block": "Bloc de verrues du Nether",
  "block.minecraft.netherite_block": "Bloc de netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc musical",
  "block.minecraft.oak_button": "Bouton en chêne",
  "block.minecraft.oak_door": "Porte en chêne",
  "block.minecraft.oak_fence": "Clôture en chêne",
  "block.minecraft.oak_fence_gate": "Porte de clôture en chêne",
  "block.minecraft.oak_hanging_sign": "Pancarte suspendue en chêne",
  "block.minecraft.oak_leaves": "Feuilles de chêne",
  "block.minecraft.oak_log": "Bûche de chêne",
  "block.minecraft.oak_planks": "Planches de chêne",
  "block.minecraft.oak_pressure_plate": "Plaque de pression en chêne",
  "block.minecraft.oak_sapling": "Pousse de chêne",
  "block.minecraft.oak_shelf": "Étagère en chêne",
  "block.minecraft.oak_sign": "Pancarte en chêne",
  "block.minecraft.oak_slab": "Dalle en chêne",
  "block.minecraft.oak_stairs": "Escaliers en chêne",
  "block.minecraft.oak_trapdoor": "Trappe en chêne",
  "block.minecraft.oak_wall_hanging_sign": "Pancarte suspendue murale en chêne",
  "block.minecraft.oak_wall_sign": "Pancarte murale en chêne",
  "block.minecraft.oak_wood": "Bois de chêne",
  "block.minecraft.observer": "Observateur",
  "block.minecraft.obsidian": "Obsidienne",
  "block.minecraft.ochre_froglight": "Grenoumière ocrée",
  "block.minecraft.ominous_banner": "Bannière sinistre",
  "block.minecraft.open_eyeblossom": "Oeillet ouvert",
  "block.minecraft.orange_banner": "Bannière d'orangé",
  "block.minecraft.orange_bed": "Lit orange",
  "block.minecraft.orange_candle": "Bougie orange",
  "block.minecraft.orange_candle_cake": "Gâteau avec bougie orange",
  "block.minecraft.orange_carpet": "Tapis orange",
  "block.minecraft.orange_concrete": "Béton orange",
  "block.minecraft.orange_concrete_powder": "Béton orange en poudre",
  "block.minecraft.orange_glazed_terracotta": "Terracotta émaillée orange",
  "block.minecraft.orange_shulker_box": "Boîte de Shulker orange",
  "block.minecraft.orange_stained_glass": "Verre orange",
  "block.minecraft.orange_stained_glass_pane": "Vitre orange",
  "block.minecraft.orange_terracotta": "Terracotta orange",
  "block.minecraft.orange_tulip": "Tulipe orange",
  "block.minecraft.orange_wool": "Laine orange",
  "block.minecraft.oxeye_daisy": "Marguerite",
  "block.minecraft.oxidized_chiseled_copper": "Cuivre ciselé oxydé",
  "block.minecraft.oxidized_copper": "Bloc de cuivre oxydé",
  "block.minecraft.oxidized_copper_bars": "Barreaux de cuivre oxydé",
  "block.minecraft.oxidized_copper_bulb": "Lampe en cuivre oxydé",
  "block.minecraft.oxidized_copper_chain": "Chaîne en cuivre oxydé",
  "block.minecraft.oxidized_copper_chest": "Coffre en cuivre oxydé",
  "block.minecraft.oxidized_copper_door": "Porte en cuivre oxydé",
  "block.minecraft.oxidized_copper_golem_statue": "Statue de golem de cuivre oxydé",
  "block.minecraft.oxidized_copper_grate": "Grille en cuivre oxydé",
  "block.minecraft.oxidized_copper_lantern": "Lanterne en cuivre oxydé",
  "block.minecraft.oxidized_copper_trapdoor": "Trappe en cuivre oxydé",
  "block.minecraft.oxidized_cut_copper": "Cuivre taillé oxydé",
  "block.minecraft.oxidized_cut_copper_slab": "Dalle de cuivre taillé oxydé",
  "block.minecraft.oxidized_cut_copper_stairs": "Escaliers de cuivre taillé oxydé",
  "block.minecraft.oxidized_lightning_rod": "Paratonnerre oxydé",
  "block.minecraft.packed_ice": "Glace compactée",
  "block.minecraft.packed_mud": "Terre crue",
  "block.minecraft.pale_hanging_moss": "Mousse pâle suspendue",
  "block.minecraft.pale_moss_block": "Bloc de mousse pâle",
  "block.minecraft.pale_moss_carpet": "Tapis de mousse pâle",
  "block.minecraft.pale_oak_button": "Bouton en chêne blanc",
  "block.minecraft.pale_oak_door": "Porte en chêne blanc",
  "block.minecraft.pale_oak_fence": "Clôture en chêne blanc",
  "block.minecraft.pale_oak_fence_gate": "Porte de clôture en chêne blanc",
  "block.minecraft.pale_oak_hanging_sign": "Pancarte suspendue en chêne blanc",
  "block.minecraft.pale_oak_leaves": "Feuilles de chêne blanc",
  "block.minecraft.pale_oak_log": "Bûche de chêne blanc",
  "block.minecraft.pale_oak_planks": "Planches de chêne blanc",
  "block.minecraft.pale_oak_pressure_plate": "Plaque de pression en chêne blanc",
  "block.minecraft.pale_oak_sapling": "Pousse de chêne blanc",
  "block.minecraft.pale_oak_shelf": "Étagère en chêne blanc",
  "block.minecraft.pale_oak_sign": "Pancarte en chêne blanc",
  "block.minecraft.pale_oak_slab": "Dalle en chêne blanc",
  "block.minecraft.pale_oak_stairs": "Escaliers en chêne blanc",
  "block.minecraft.pale_oak_trapdoor": "Trappe en chêne blanc",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pancarte suspendue murale en chêne blanc",
  "block.minecraft.pale_oak_wall_sign": "Pancarte murale en chêne blanc",
  "block.minecraft.pale_oak_wood": "Bois de chêne blanc",
  "block.minecraft.pearlescent_froglight": "Grenoumière nacrée",
  "block.minecraft.peony": "Pivoines",
  "block.minecraft.petrified_oak_slab": "Dalle en chêne pétrifiée",
  "block.minecraft.piglin_head": "Tête de Piglin",
  "block.minecraft.piglin_wall_head": "Tête de Piglin murale",
  "block.minecraft.pink_banner": "Bannière de carnation",
  "block.minecraft.pink_bed": "Lit rose",
  "block.minecraft.pink_candle": "Bougie rose",
  "block.minecraft.pink_candle_cake": "Gâteau avec bougie rose",
  "block.minecraft.pink_carpet": "Tapis rose",
  "block.minecraft.pink_concrete": "Béton rose",
  "block.minecraft.pink_concrete_powder": "Béton rose en poudre",
  "block.minecraft.pink_glazed_terracotta": "Terracotta émaillée rose",
  "block.minecraft.pink_petals": "Pétales roses",
  "block.minecraft.pink_shulker_box": "Boîte de Shulker rose",
  "block.minecraft.pink_stained_glass": "Verre rose",
  "block.minecraft.pink_stained_glass_pane": "Vitre rose",
  "block.minecraft.pink_terracotta": "Terracotta rose",
  "block.minecraft.pink_tulip": "Tulipe rose",
  "block.minecraft.pink_wool": "Laine rose",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Tête de piston",
  "block.minecraft.pitcher_crop": "Plant de plante pichet",
  "block.minecraft.pitcher_plant": "Plante pichet",
  "block.minecraft.player_head": "Tête de joueur",
  "block.minecraft.player_head.named": "Tête de %s",
  "block.minecraft.player_wall_head": "Tête de joueur murale",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Pointe de spéléothème",
  "block.minecraft.polished_andesite": "Andésite polie",
  "block.minecraft.polished_andesite_slab": "Dalle d'andésite polie",
  "block.minecraft.polished_andesite_stairs": "Escaliers d'andésite polie",
  "block.minecraft.polished_basalt": "Basalte poli",
  "block.minecraft.polished_blackstone": "Blackstone polie",
  "block.minecraft.polished_blackstone_brick_slab": "Dalle de briques de blackstone polie",
  "block.minecraft.polished_blackstone_brick_stairs": "Escaliers de briques de blackstone polie",
  "block.minecraft.polished_blackstone_brick_wall": "Muret de briques de blackstone polie",
  "block.minecraft.polished_blackstone_bricks": "Briques de blackstone polie",
  "block.minecraft.polished_blackstone_button": "Bouton de blackstone polie",
  "block.minecraft.polished_blackstone_pressure_plate": "Plaque de pression de blackstone polie",
  "block.minecraft.polished_blackstone_slab": "Dalle de blackstone polie",
  "block.minecraft.polished_blackstone_stairs": "Escaliers de blackstone polie",
  "block.minecraft.polished_blackstone_wall": "Muret de blackstone polie",
  "block.minecraft.polished_deepslate": "Profondoise polie",
  "block.minecraft.polished_deepslate_slab": "Dalle de profondoise polie",
  "block.minecraft.polished_deepslate_stairs": "Escaliers de profondoise polie",
  "block.minecraft.polished_deepslate_wall": "Muret de profondoise polie",
  "block.minecraft.polished_diorite": "Diorite polie",
  "block.minecraft.polished_diorite_slab": "Dalle de diorite polie",
  "block.minecraft.polished_diorite_stairs": "Escaliers de diorite polie",
  "block.minecraft.polished_granite": "Granite poli",
  "block.minecraft.polished_granite_slab": "Dalle de granite poli",
  "block.minecraft.polished_granite_stairs": "Escaliers de granite poli",
  "block.minecraft.polished_tuff": "Tuf poli",
  "block.minecraft.polished_tuff_slab": "Dalle de tuf poli",
  "block.minecraft.polished_tuff_stairs": "Escaliers de tuf poli",
  "block.minecraft.polished_tuff_wall": "Muret de tuf poli",
  "block.minecraft.poppy": "Coquelicot",
  "block.minecraft.potatoes": "Patates",
  "block.minecraft.potted_acacia_sapling": "Pousse d'acacia en pot",
  "block.minecraft.potted_allium": "Allium en pot",
  "block.minecraft.potted_azalea_bush": "Azalée en pot",
  "block.minecraft.potted_azure_bluet": "Houstonies bleues en pot",
  "block.minecraft.potted_bamboo": "Bambou en pot",
  "block.minecraft.potted_birch_sapling": "Pousse de bouleau en pot",
  "block.minecraft.potted_blue_orchid": "Orchidées bleues en pot",
  "block.minecraft.potted_brown_mushroom": "Champignon brun en pot",
  "block.minecraft.potted_cactus": "Cactus en pot",
  "block.minecraft.potted_cherry_sapling": "Pousse de cerisier en pot",
  "block.minecraft.potted_closed_eyeblossom": "Œillet fermé en pot",
  "block.minecraft.potted_cornflower": "Centaurée bleuet en pot",
  "block.minecraft.potted_crimson_fungus": "Champignon cramoisi en pot",
  "block.minecraft.potted_crimson_roots": "Racines cramoisies en pot",
  "block.minecraft.potted_dandelion": "Pissenlit en pot",
  "block.minecraft.potted_dark_oak_sapling": "Pousse de chêne noir en pot",
  "block.minecraft.potted_dead_bush": "Buisson mort en pot",
  "block.minecraft.potted_fern": "Fougère en pot",
  "block.minecraft.potted_flowering_azalea_bush": "Azalée en fleurs en pot",
  "block.minecraft.potted_golden_dandelion": "Pissenlit doré en pot",
  "block.minecraft.potted_jungle_sapling": "Pousse d'acajou en pot",
  "block.minecraft.potted_lily_of_the_valley": "Muguet en pot",
  "block.minecraft.potted_mangrove_propagule": "Propagule de palétuvier en pot",
  "block.minecraft.potted_oak_sapling": "Pousse de chêne en pot",
  "block.minecraft.potted_open_eyeblossom": "Œillet ouvert en pot",
  "block.minecraft.potted_orange_tulip": "Tulipe orange en pot",
  "block.minecraft.potted_oxeye_daisy": "Marguerite en pot",
  "block.minecraft.potted_pale_oak_sapling": "Pousse de chêne blanc en pot",
  "block.minecraft.potted_pink_tulip": "Tulipe rose en pot",
  "block.minecraft.potted_poppy": "Coquelicot en pot",
  "block.minecraft.potted_red_mushroom": "Champignon rouge en pot",
  "block.minecraft.potted_red_tulip": "Tulipe rouge en pot",
  "block.minecraft.potted_spruce_sapling": "Pousse d'épinette en pot",
  "block.minecraft.potted_torchflower": "Torche-fleur en pot",
  "block.minecraft.potted_warped_fungus": "Champignon tordu en pot",
  "block.minecraft.potted_warped_roots": "Racines tordues en pot",
  "block.minecraft.potted_white_tulip": "Tulipe blanche en pot",
  "block.minecraft.potted_wither_rose": "Rose de Wither en pot",
  "block.minecraft.powder_snow": "Neige poudreuse",
  "block.minecraft.powder_snow_cauldron": "Chaudron de neige poudreuse",
  "block.minecraft.powered_rail": "Rails propulseurs",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Dalle de briques de prismarine",
  "block.minecraft.prismarine_brick_stairs": "Escaliers de briques de prismarine",
  "block.minecraft.prismarine_bricks": "Briques de prismarine",
  "block.minecraft.prismarine_slab": "Dalle de prismarine",
  "block.minecraft.prismarine_stairs": "Escaliers de prismarine",
  "block.minecraft.prismarine_wall": "Muret de prismarine",
  "block.minecraft.pumpkin": "Citrouille",
  "block.minecraft.pumpkin_stem": "Tige de citrouille",
  "block.minecraft.purple_banner": "Bannière de mûre",
  "block.minecraft.purple_bed": "Lit mauve",
  "block.minecraft.purple_candle": "Bougie mauve",
  "block.minecraft.purple_candle_cake": "Gâteau avec bougie mauve",
  "block.minecraft.purple_carpet": "Tapis mauve",
  "block.minecraft.purple_concrete": "Béton mauve",
  "block.minecraft.purple_concrete_powder": "Béton mauve en poudre",
  "block.minecraft.purple_glazed_terracotta": "Terracotta émaillée mauve",
  "block.minecraft.purple_shulker_box": "Boîte de Shulker mauve",
  "block.minecraft.purple_stained_glass": "Verre mauve",
  "block.minecraft.purple_stained_glass_pane": "Vitre mauve",
  "block.minecraft.purple_terracotta": "Terracotta mauve",
  "block.minecraft.purple_wool": "Laine mauve",
  "block.minecraft.purpur_block": "Bloc de purpur",
  "block.minecraft.purpur_pillar": "Pilier de purpur",
  "block.minecraft.purpur_slab": "Dalle de purpur",
  "block.minecraft.purpur_stairs": "Escaliers de purpur",
  "block.minecraft.quartz_block": "Bloc de quartz",
  "block.minecraft.quartz_bricks": "Briques de quartz",
  "block.minecraft.quartz_pillar": "Pilier de quartz",
  "block.minecraft.quartz_slab": "Dalle de quartz",
  "block.minecraft.quartz_stairs": "Escaliers de quartz",
  "block.minecraft.rail": "Rails",
  "block.minecraft.raw_copper_block": "Bloc de cuivre brut",
  "block.minecraft.raw_gold_block": "Bloc d'or brut",
  "block.minecraft.raw_iron_block": "Bloc de fer brut",
  "block.minecraft.red_banner": "Bannière de gueules",
  "block.minecraft.red_bed": "Lit rouge",
  "block.minecraft.red_candle": "Bougie rouge",
  "block.minecraft.red_candle_cake": "Gâteau avec bougie rouge",
  "block.minecraft.red_carpet": "Tapis rouge",
  "block.minecraft.red_concrete": "Béton rouge",
  "block.minecraft.red_concrete_powder": "Béton rouge en poudre",
  "block.minecraft.red_glazed_terracotta": "Terracotta émaillée rouge",
  "block.minecraft.red_mushroom": "Champignon rouge",
  "block.minecraft.red_mushroom_block": "Bloc de champignon rouge",
  "block.minecraft.red_nether_brick_slab": "Dalle de briques rouges du Nether",
  "block.minecraft.red_nether_brick_stairs": "Escaliers de briques rouges du Nether",
  "block.minecraft.red_nether_brick_wall": "Muret de briques rouges du Nether",
  "block.minecraft.red_nether_bricks": "Briques rouges du Nether",
  "block.minecraft.red_sand": "Sable rouge",
  "block.minecraft.red_sandstone": "Grès rouge",
  "block.minecraft.red_sandstone_slab": "Dalle de grès rouge",
  "block.minecraft.red_sandstone_stairs": "Escaliers de grès rouge",
  "block.minecraft.red_sandstone_wall": "Muret de grès rouge",
  "block.minecraft.red_shulker_box": "Boîte de Shulker rouge",
  "block.minecraft.red_stained_glass": "Verre rouge",
  "block.minecraft.red_stained_glass_pane": "Vitre rouge",
  "block.minecraft.red_terracotta": "Terracotta rouge",
  "block.minecraft.red_tulip": "Tulipe rouge",
  "block.minecraft.red_wool": "Laine rouge",
  "block.minecraft.redstone_block": "Bloc de redstone",
  "block.minecraft.redstone_lamp": "Lampe à redstone",
  "block.minecraft.redstone_ore": "Minerai de redstone",
  "block.minecraft.redstone_torch": "Torche de redstone",
  "block.minecraft.redstone_wall_torch": "Torche de redstone murale",
  "block.minecraft.redstone_wire": "Traînée de redstone",
  "block.minecraft.reinforced_deepslate": "Profondoise renforcée",
  "block.minecraft.repeater": "Répéteur de redstone",
  "block.minecraft.repeating_command_block": "Bloc de commande à répétition",
  "block.minecraft.resin_block": "Bloc de résine",
  "block.minecraft.resin_brick_slab": "Dalle de briques de résine",
  "block.minecraft.resin_brick_stairs": "Escaliers de briques de résine",
  "block.minecraft.resin_brick_wall": "Muret de briques de résine",
  "block.minecraft.resin_bricks": "Briques de résine",
  "block.minecraft.resin_clump": "Résine",
  "block.minecraft.respawn_anchor": "Ancre de respawn",
  "block.minecraft.rooted_dirt": "Terre racineuse",
  "block.minecraft.rose_bush": "Rosier",
  "block.minecraft.sand": "Sable",
  "block.minecraft.sandstone": "Grès",
  "block.minecraft.sandstone_slab": "Dalle de grès",
  "block.minecraft.sandstone_stairs": "Escaliers de grès",
  "block.minecraft.sandstone_wall": "Muret de grès",
  "block.minecraft.scaffolding": "Échafaudage",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalyseur de sculk",
  "block.minecraft.sculk_sensor": "Capteur sculk",
  "block.minecraft.sculk_shrieker": "Hurleur sculk",
  "block.minecraft.sculk_vein": "Veine de sculk",
  "block.minecraft.sea_lantern": "Lanterne de mer",
  "block.minecraft.sea_pickle": "Cornichon de mer",
  "block.minecraft.seagrass": "Herbe marine",
  "block.minecraft.set_spawn": "Point de respawn défini",
  "block.minecraft.short_dry_grass": "Herbe sèche courte",
  "block.minecraft.short_grass": "Herbe courte",
  "block.minecraft.shroomlight": "Lampignon",
  "block.minecraft.shulker_box": "Boîte de Shulker",
  "block.minecraft.skeleton_skull": "Crâne de squelette",
  "block.minecraft.skeleton_wall_skull": "Crâne de squelette mural",
  "block.minecraft.slime_block": "Bloc de slime",
  "block.minecraft.small_amethyst_bud": "Petit bourgeon d'améthyste",
  "block.minecraft.small_dripleaf": "Petites platefeuilles",
  "block.minecraft.smithing_table": "Table de forge",
  "block.minecraft.smoker": "Fumoir",
  "block.minecraft.smooth_basalt": "Basalte lisse",
  "block.minecraft.smooth_quartz": "Quartz lisse",
  "block.minecraft.smooth_quartz_slab": "Dalle de quartz lisse",
  "block.minecraft.smooth_quartz_stairs": "Escaliers de quartz lisse",
  "block.minecraft.smooth_red_sandstone": "Grès rouge lisse",
  "block.minecraft.smooth_red_sandstone_slab": "Dalle de grès rouge lisse",
  "block.minecraft.smooth_red_sandstone_stairs": "Escaliers de grès rouge lisse",
  "block.minecraft.smooth_sandstone": "Grès lisse",
  "block.minecraft.smooth_sandstone_slab": "Dalle de grès lisse",
  "block.minecraft.smooth_sandstone_stairs": "Escaliers de grès lisse",
  "block.minecraft.smooth_stone": "Pierre lisse",
  "block.minecraft.smooth_stone_slab": "Dalle de pierre lisse",
  "block.minecraft.sniffer_egg": "Oeuf de renifleur",
  "block.minecraft.snow": "Neige",
  "block.minecraft.snow_block": "Bloc de neige",
  "block.minecraft.soul_campfire": "Feu de camp des damnés",
  "block.minecraft.soul_fire": "Feu des damnés",
  "block.minecraft.soul_lantern": "Lanterne des damnés",
  "block.minecraft.soul_sand": "Sable des damnés",
  "block.minecraft.soul_soil": "Terre des damnés",
  "block.minecraft.soul_torch": "Torche des damnés",
  "block.minecraft.soul_wall_torch": "Torche des damnés murale",
  "block.minecraft.spawn.not_valid": "Vous n'avez pas de lit ou d'ancre de respawn chargée, ou le bloc a été obstrué",
  "block.minecraft.spawner": "Spawneur de mobs",
  "block.minecraft.spawner.desc1": "Interaction avec un œuf spawneur :",
  "block.minecraft.spawner.desc2": "Définit le type de mob",
  "block.minecraft.sponge": "Éponge",
  "block.minecraft.spore_blossom": "Fleur sporifère",
  "block.minecraft.spruce_button": "Bouton en épinette",
  "block.minecraft.spruce_door": "Porte en épinette",
  "block.minecraft.spruce_fence": "Clôture en épinette",
  "block.minecraft.spruce_fence_gate": "Porte de clôture en épinette",
  "block.minecraft.spruce_hanging_sign": "Pancarte suspendue en épinette",
  "block.minecraft.spruce_leaves": "Feuilles d'épinette",
  "block.minecraft.spruce_log": "Bûche d'épinette",
  "block.minecraft.spruce_planks": "Planches d'épinette",
  "block.minecraft.spruce_pressure_plate": "Plaque de pression en épinette",
  "block.minecraft.spruce_sapling": "Pousse d'épinette",
  "block.minecraft.spruce_shelf": "Étagère en épinette",
  "block.minecraft.spruce_sign": "Pancarte en épinette",
  "block.minecraft.spruce_slab": "Dalle en épinette",
  "block.minecraft.spruce_stairs": "Escaliers en épinette",
  "block.minecraft.spruce_trapdoor": "Trappe en épinette",
  "block.minecraft.spruce_wall_hanging_sign": "Pancarte suspendue murale en épinette",
  "block.minecraft.spruce_wall_sign": "Pancarte murale en épinette",
  "block.minecraft.spruce_wood": "Bois d'épinette",
  "block.minecraft.sticky_piston": "Piston collant",
  "block.minecraft.stone": "Roche",
  "block.minecraft.stone_brick_slab": "Dalle de briques de pierre",
  "block.minecraft.stone_brick_stairs": "Escaliers de briques de pierre",
  "block.minecraft.stone_brick_wall": "Muret de briques de pierre",
  "block.minecraft.stone_bricks": "Briques de pierre",
  "block.minecraft.stone_button": "Bouton de pierre",
  "block.minecraft.stone_pressure_plate": "Plaque de pression de pierre",
  "block.minecraft.stone_slab": "Dalle de pierre",
  "block.minecraft.stone_stairs": "Escaliers de pierre",
  "block.minecraft.stonecutter": "Tailleur de pierre",
  "block.minecraft.stripped_acacia_log": "Bûche d'acacia écorcée",
  "block.minecraft.stripped_acacia_wood": "Bois d'acacia écorcé",
  "block.minecraft.stripped_bamboo_block": "Bloc de bambou écorcé",
  "block.minecraft.stripped_birch_log": "Bûche de bouleau écorcée",
  "block.minecraft.stripped_birch_wood": "Bois de bouleau écorcé",
  "block.minecraft.stripped_cherry_log": "Bûche de cerisier écorcée",
  "block.minecraft.stripped_cherry_wood": "Bois de cerisier écorcé",
  "block.minecraft.stripped_crimson_hyphae": "Hyphes cramoisies dénudées",
  "block.minecraft.stripped_crimson_stem": "Tige cramoisie dénudée",
  "block.minecraft.stripped_dark_oak_log": "Bûche de chêne noir écorcée",
  "block.minecraft.stripped_dark_oak_wood": "Bois de chêne noir écorcé",
  "block.minecraft.stripped_jungle_log": "Bûche d'acajou écorcée",
  "block.minecraft.stripped_jungle_wood": "Bois d'acajou écorcé",
  "block.minecraft.stripped_mangrove_log": "Bûche de palétuvier écorcée",
  "block.minecraft.stripped_mangrove_wood": "Bois de palétuvier écorcé",
  "block.minecraft.stripped_oak_log": "Bûche de chêne écorcée",
  "block.minecraft.stripped_oak_wood": "Bois de chêne écorcé",
  "block.minecraft.stripped_pale_oak_log": "Bûche de chêne blanc écorcée",
  "block.minecraft.stripped_pale_oak_wood": "Bois de chêne blanc écorcé",
  "block.minecraft.stripped_spruce_log": "Bûche d'épinette écorcée",
  "block.minecraft.stripped_spruce_wood": "Bois d'épinette écorcé",
  "block.minecraft.stripped_warped_hyphae": "Hyphes tordues dénudées",
  "block.minecraft.stripped_warped_stem": "Tige tordue dénudée",
  "block.minecraft.structure_block": "Bloc de structure",
  "block.minecraft.structure_void": "Vide de structure",
  "block.minecraft.sugar_cane": "Cannes à sucre",
  "block.minecraft.sunflower": "Tournesol",
  "block.minecraft.suspicious_gravel": "Gravelle suspecte",
  "block.minecraft.suspicious_sand": "Sable suspect",
  "block.minecraft.sweet_berry_bush": "Buisson de baies sucrées",
  "block.minecraft.tall_dry_grass": "Herbe sèche",
  "block.minecraft.tall_grass": "Herbe haute",
  "block.minecraft.tall_seagrass": "Herbe marine haute",
  "block.minecraft.target": "Cible",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Bloc de test",
  "block.minecraft.test_instance_block": "Bloc d'instance de test",
  "block.minecraft.tinted_glass": "Verre teinté",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Les explosions de TNT sont désactivées",
  "block.minecraft.torch": "Torche",
  "block.minecraft.torchflower": "Torche-fleur",
  "block.minecraft.torchflower_crop": "Plant de torche-fleur",
  "block.minecraft.trapped_chest": "Coffre piégé",
  "block.minecraft.trial_spawner": "Spawneur des épreuves",
  "block.minecraft.tripwire": "Fil de déclenchement",
  "block.minecraft.tripwire_hook": "Crochet",
  "block.minecraft.tube_coral": "Corail tube",
  "block.minecraft.tube_coral_block": "Bloc de corail tube",
  "block.minecraft.tube_coral_fan": "Gorgone de corail tube",
  "block.minecraft.tube_coral_wall_fan": "Gorgone de corail tube murale",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Dalle de briques de tuf",
  "block.minecraft.tuff_brick_stairs": "Escaliers de briques de tuf",
  "block.minecraft.tuff_brick_wall": "Muret de briques de tuf",
  "block.minecraft.tuff_bricks": "Briques de tuf",
  "block.minecraft.tuff_slab": "Dalle de tuf",
  "block.minecraft.tuff_stairs": "Escaliers de tuf",
  "block.minecraft.tuff_wall": "Muret de tuf",
  "block.minecraft.turtle_egg": "Oeuf de tortue",
  "block.minecraft.twisting_vines": "Lianes torsadées",
  "block.minecraft.twisting_vines_plant": "Plante de lianes torsadées",
  "block.minecraft.vault": "Coffre-fort",
  "block.minecraft.verdant_froglight": "Grenoumière verdoyante",
  "block.minecraft.vine": "Lianes",
  "block.minecraft.void_air": "Air du vide",
  "block.minecraft.wall_torch": "Torche murale",
  "block.minecraft.warped_button": "Bouton tordu",
  "block.minecraft.warped_door": "Porte tordue",
  "block.minecraft.warped_fence": "Clôture tordue",
  "block.minecraft.warped_fence_gate": "Porte de clôture tordue",
  "block.minecraft.warped_fungus": "Champignon tordu",
  "block.minecraft.warped_hanging_sign": "Pancarte suspendue tordue",
  "block.minecraft.warped_hyphae": "Hyphes tordues",
  "block.minecraft.warped_nylium": "Nylium tordu",
  "block.minecraft.warped_planks": "Planches tordues",
  "block.minecraft.warped_pressure_plate": "Plaque de pression tordue",
  "block.minecraft.warped_roots": "Racines tordues",
  "block.minecraft.warped_shelf": "Étagère tordue",
  "block.minecraft.warped_sign": "Pancarte tordue",
  "block.minecraft.warped_slab": "Dalle tordue",
  "block.minecraft.warped_stairs": "Escaliers tordus",
  "block.minecraft.warped_stem": "Tige tordue",
  "block.minecraft.warped_trapdoor": "Trappe tordue",
  "block.minecraft.warped_wall_hanging_sign": "Pancarte suspendue murale tordue",
  "block.minecraft.warped_wall_sign": "Pancarte murale tordue",
  "block.minecraft.warped_wart_block": "Bloc de verrues tordues",
  "block.minecraft.water": "Eau",
  "block.minecraft.water_cauldron": "Chaudron d'eau",
  "block.minecraft.waxed_chiseled_copper": "Cuivre ciselé ciré",
  "block.minecraft.waxed_copper_bars": "Barreaux de cuivre ciré",
  "block.minecraft.waxed_copper_block": "Bloc de cuivre ciré",
  "block.minecraft.waxed_copper_bulb": "Lampe en cuivre ciré",
  "block.minecraft.waxed_copper_chain": "Chaîne en cuivre ciré",
  "block.minecraft.waxed_copper_chest": "Coffre en cuivre ciré",
  "block.minecraft.waxed_copper_door": "Porte en cuivre ciré",
  "block.minecraft.waxed_copper_golem_statue": "Statue de golem de cuivre ciré",
  "block.minecraft.waxed_copper_grate": "Grille en cuivre ciré",
  "block.minecraft.waxed_copper_lantern": "Lanterne en cuivre ciré",
  "block.minecraft.waxed_copper_trapdoor": "Trappe en cuivre ciré",
  "block.minecraft.waxed_cut_copper": "Cuivre taillé ciré",
  "block.minecraft.waxed_cut_copper_slab": "Dalle de cuivre taillé ciré",
  "block.minecraft.waxed_cut_copper_stairs": "Escaliers de cuivre taillé ciré",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cuivre ciselé exposé ciré",
  "block.minecraft.waxed_exposed_copper": "Bloc de cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_bars": "Barreaux de cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_bulb": "Lampe en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_chain": "Chaîne en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_chest": "Coffre en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_door": "Porte en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statue de golem de cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_grate": "Grille en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterne en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trappe en cuivre exposé ciré",
  "block.minecraft.waxed_exposed_cut_copper": "Cuivre taillé exposé ciré",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Dalle de cuivre taillé exposé ciré",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escaliers de cuivre taillé exposé ciré",
  "block.minecraft.waxed_exposed_lightning_rod": "Paratonnerre exposé ciré",
  "block.minecraft.waxed_lightning_rod": "Paratonnerre ciré",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cuivre ciselé oxydé ciré",
  "block.minecraft.waxed_oxidized_copper": "Bloc de cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_bars": "Barreaux de cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lampe en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_chain": "Chaîne en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_chest": "Coffre en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_door": "Porte en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statue de golem de cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_grate": "Grille en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterne en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trappe en cuivre oxydé ciré",
  "block.minecraft.waxed_oxidized_cut_copper": "Cuivre taillé oxydé ciré",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Dalle de cuivre taillé oxydé ciré",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escaliers de cuivre taillé oxydé ciré",
  "block.minecraft.waxed_oxidized_lightning_rod": "Paratonnerre oxydé ciré",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cuivre ciselé patiné ciré",
  "block.minecraft.waxed_weathered_copper": "Bloc de cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_bars": "Barreaux de cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_bulb": "Lampe en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_chain": "Chaîne en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_chest": "Coffre en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_door": "Porte en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statue de golem de cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_grate": "Grille en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterne en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trappe en cuivre patiné ciré",
  "block.minecraft.waxed_weathered_cut_copper": "Cuivre taillé patiné ciré",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Dalle de cuivre taillé patiné ciré",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escaliers de cuivre taillé patiné ciré",
  "block.minecraft.waxed_weathered_lightning_rod": "Paratonnerre patiné ciré",
  "block.minecraft.weathered_chiseled_copper": "Cuivre ciselé patiné",
  "block.minecraft.weathered_copper": "Bloc de cuivre patiné",
  "block.minecraft.weathered_copper_bars": "Barreaux de cuivre patiné",
  "block.minecraft.weathered_copper_bulb": "Lampe en cuivre patiné",
  "block.minecraft.weathered_copper_chain": "Chaîne en cuivre patiné",
  "block.minecraft.weathered_copper_chest": "Coffre en cuivre patiné",
  "block.minecraft.weathered_copper_door": "Porte en cuivre patiné",
  "block.minecraft.weathered_copper_golem_statue": "Statue de golem de cuivre patiné",
  "block.minecraft.weathered_copper_grate": "Grille en cuivre patiné",
  "block.minecraft.weathered_copper_lantern": "Lanterne en cuivre patiné",
  "block.minecraft.weathered_copper_trapdoor": "Trappe en cuivre patiné",
  "block.minecraft.weathered_cut_copper": "Cuivre taillé patiné",
  "block.minecraft.weathered_cut_copper_slab": "Dalle de cuivre taillé patiné",
  "block.minecraft.weathered_cut_copper_stairs": "Escaliers de cuivre taillé patiné",
  "block.minecraft.weathered_lightning_rod": "Paratonnerre patiné",
  "block.minecraft.weeping_vines": "Lianes pleureuses",
  "block.minecraft.weeping_vines_plant": "Plante de lianes pleureuses",
  "block.minecraft.wet_sponge": "Éponge mouillée",
  "block.minecraft.wheat": "Plants de blé",
  "block.minecraft.white_banner": "Bannière d'argent",
  "block.minecraft.white_bed": "Lit blanc",
  "block.minecraft.white_candle": "Bougie blanche",
  "block.minecraft.white_candle_cake": "Gâteau avec bougie blanche",
  "block.minecraft.white_carpet": "Tapis blanc",
  "block.minecraft.white_concrete": "Béton blanc",
  "block.minecraft.white_concrete_powder": "Béton blanc en poudre",
  "block.minecraft.white_glazed_terracotta": "Terracotta émaillée blanche",
  "block.minecraft.white_shulker_box": "Boîte de Shulker blanche",
  "block.minecraft.white_stained_glass": "Verre blanc",
  "block.minecraft.white_stained_glass_pane": "Vitre blanche",
  "block.minecraft.white_terracotta": "Terracotta blanche",
  "block.minecraft.white_tulip": "Tulipe blanche",
  "block.minecraft.white_wool": "Laine blanche",
  "block.minecraft.wildflowers": "Fleurs sauvages",
  "block.minecraft.wither_rose": "Rose de Wither",
  "block.minecraft.wither_skeleton_skull": "Crâne de squelette Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Crâne de squelette Wither mural",
  "block.minecraft.yellow_banner": "Bannière d'or",
  "block.minecraft.yellow_bed": "Lit jaune",
  "block.minecraft.yellow_candle": "Bougie jaune",
  "block.minecraft.yellow_candle_cake": "Gâteau avec bougie jaune",
  "block.minecraft.yellow_carpet": "Tapis jaune",
  "block.minecraft.yellow_concrete": "Béton jaune",
  "block.minecraft.yellow_concrete_powder": "Béton jaune en poudre",
  "block.minecraft.yellow_glazed_terracotta": "Terracotta émaillée jaune",
  "block.minecraft.yellow_shulker_box": "Boîte de Shulker jaune",
  "block.minecraft.yellow_stained_glass": "Verre jaune",
  "block.minecraft.yellow_stained_glass_pane": "Vitre jaune",
  "block.minecraft.yellow_terracotta": "Terracotta jaune",
  "block.minecraft.yellow_wool": "Laine jaune",
  "block.minecraft.zombie_head": "Tête de zombie",
  "block.minecraft.zombie_wall_head": "Tête de zombie murale",
  "item.minecraft.acacia_boat": "Bateau en acacia",
  "item.minecraft.acacia_chest_boat": "Bateau de stockage en acacia",
  "item.minecraft.allay_spawn_egg": "Oeuf spawneur d'Allay",
  "item.minecraft.amethyst_shard": "Éclat d'améthyste",
  "item.minecraft.angler_pottery_shard": "Tesson de poterie de pêcheur",
  "item.minecraft.angler_pottery_sherd": "Tesson de poterie de pêcheur",
  "item.minecraft.apple": "Pomme",
  "item.minecraft.archer_pottery_shard": "Tesson de poterie d'archer",
  "item.minecraft.archer_pottery_sherd": "Tesson de poterie d'archer",
  "item.minecraft.armadillo_scute": "Écaille de tatou",
  "item.minecraft.armadillo_spawn_egg": "Oeuf spawneur de tatou",
  "item.minecraft.armor_stand": "Porte-armure",
  "item.minecraft.arms_up_pottery_shard": "Tesson de poterie de mains en l'air",
  "item.minecraft.arms_up_pottery_sherd": "Tesson de poterie de mains en l'air",
  "item.minecraft.arrow": "Flèche",
  "item.minecraft.axolotl_bucket": "Axolotl dans une chaudière",
  "item.minecraft.axolotl_spawn_egg": "Oeuf spawneur d'axolotl",
  "item.minecraft.baked_potato": "Patate cuite",
  "item.minecraft.bamboo_chest_raft": "Radeau de stockage en bambou",
  "item.minecraft.bamboo_raft": "Radeau en bambou",
  "item.minecraft.bat_spawn_egg": "Oeuf spawneur de chauve-souris",
  "item.minecraft.bee_spawn_egg": "Oeuf spawneur d'abeille",
  "item.minecraft.beef": "Steak cru",
  "item.minecraft.beetroot": "Betterave",
  "item.minecraft.beetroot_seeds": "Graines de betterave",
  "item.minecraft.beetroot_soup": "Soupe aux betteraves",
  "item.minecraft.birch_boat": "Bateau en bouleau",
  "item.minecraft.birch_chest_boat": "Bateau de stockage en bouleau",
  "item.minecraft.black_bundle": "Sac noir",
  "item.minecraft.black_dye": "Teinture noire",
  "item.minecraft.black_harness": "Harnais noir",
  "item.minecraft.blade_pottery_shard": "Tesson de poterie de lame",
  "item.minecraft.blade_pottery_sherd": "Tesson de poterie de lame",
  "item.minecraft.blaze_powder": "Poudre de Blaze",
  "item.minecraft.blaze_rod": "Barre de Blaze",
  "item.minecraft.blaze_spawn_egg": "Oeuf spawneur de Blaze",
  "item.minecraft.blue_bundle": "Sac bleu",
  "item.minecraft.blue_dye": "Teinture bleue",
  "item.minecraft.blue_egg": "Oeuf bleu",
  "item.minecraft.blue_harness": "Harnais bleu",
  "item.minecraft.bogged_spawn_egg": "Oeuf spawneur de marécageux",
  "item.minecraft.bolt_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornement d'armure des boulons",
  "item.minecraft.bone": "Os",
  "item.minecraft.bone_meal": "Poudre d'os",
  "item.minecraft.book": "Livre",
  "item.minecraft.bordure_indented_banner_pattern": "Motif de bannière de bordure endentée",
  "item.minecraft.bow": "Arc",
  "item.minecraft.bowl": "Bol",
  "item.minecraft.bread": "Pain",
  "item.minecraft.breeze_rod": "Barre de Breeze",
  "item.minecraft.breeze_spawn_egg": "Oeuf spawneur de Breeze",
  "item.minecraft.brewer_pottery_shard": "Tesson de poterie d'alchimiste",
  "item.minecraft.brewer_pottery_sherd": "Tesson de poterie d'alchimiste",
  "item.minecraft.brewing_stand": "Stand d'alchimie",
  "item.minecraft.brick": "Brique",
  "item.minecraft.brown_bundle": "Sac brun",
  "item.minecraft.brown_dye": "Teinture brune",
  "item.minecraft.brown_egg": "Oeuf brun",
  "item.minecraft.brown_harness": "Harnais brun",
  "item.minecraft.brush": "Pinceau",
  "item.minecraft.bucket": "Chaudière",
  "item.minecraft.bundle": "Sac",
  "item.minecraft.bundle.empty": "Vide",
  "item.minecraft.bundle.empty.description": "Peut contenir un stack d'items variés",
  "item.minecraft.bundle.full": "Plein",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Tesson de poterie de feu",
  "item.minecraft.burn_pottery_sherd": "Tesson de poterie de feu",
  "item.minecraft.camel_husk_spawn_egg": "Oeuf spawneur de dromadaire momifié",
  "item.minecraft.camel_spawn_egg": "Oeuf spawneur de dromadaire",
  "item.minecraft.carrot": "Carotte",
  "item.minecraft.carrot_on_a_stick": "Carotte sur un bâton",
  "item.minecraft.cat_spawn_egg": "Oeuf spawneur de chat",
  "item.minecraft.cauldron": "Chaudron",
  "item.minecraft.cave_spider_spawn_egg": "Oeuf spawneur d'araignée des cavernes",
  "item.minecraft.chainmail_boots": "Bottes de mailles",
  "item.minecraft.chainmail_chestplate": "Cotte de mailles",
  "item.minecraft.chainmail_helmet": "Casque de mailles",
  "item.minecraft.chainmail_leggings": "Jambières de mailles",
  "item.minecraft.charcoal": "Charbon de bois",
  "item.minecraft.cherry_boat": "Bateau en cerisier",
  "item.minecraft.cherry_chest_boat": "Bateau de stockage en cerisier",
  "item.minecraft.chest_minecart": "Wagonnet de stockage",
  "item.minecraft.chicken": "Poulet cru",
  "item.minecraft.chicken_spawn_egg": "Oeuf spawneur de poule",
  "item.minecraft.chorus_fruit": "Fruit de chorus",
  "item.minecraft.clay_ball": "Motte de glaise",
  "item.minecraft.clock": "Horloge",
  "item.minecraft.coal": "Charbon",
  "item.minecraft.coast_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornement d'armure des littoraux",
  "item.minecraft.cocoa_beans": "Fèves de cacao",
  "item.minecraft.cod": "Morue crue",
  "item.minecraft.cod_bucket": "Morue dans une chaudière",
  "item.minecraft.cod_spawn_egg": "Oeuf spawneur de morue",
  "item.minecraft.command_block_minecart": "Wagonnet avec bloc de commande",
  "item.minecraft.compass": "Boussole",
  "item.minecraft.cooked_beef": "Steak cuit",
  "item.minecraft.cooked_chicken": "Poulet cuit",
  "item.minecraft.cooked_cod": "Morue cuite",
  "item.minecraft.cooked_mutton": "Mouton cuit",
  "item.minecraft.cooked_porkchop": "Côtelette de porc cuite",
  "item.minecraft.cooked_rabbit": "Lapin cuit",
  "item.minecraft.cooked_salmon": "Saumon cuit",
  "item.minecraft.cookie": "Biscuit",
  "item.minecraft.copper_axe": "Hache en cuivre",
  "item.minecraft.copper_boots": "Bottes en cuivre",
  "item.minecraft.copper_chestplate": "Plastron en cuivre",
  "item.minecraft.copper_golem_spawn_egg": "Oeuf spawneur de golem de cuivre",
  "item.minecraft.copper_helmet": "Casque en cuivre",
  "item.minecraft.copper_hoe": "Houe en cuivre",
  "item.minecraft.copper_horse_armor": "Armure en cuivre pour cheval",
  "item.minecraft.copper_ingot": "Lingot de cuivre",
  "item.minecraft.copper_leggings": "Jambières en cuivre",
  "item.minecraft.copper_nautilus_armor": "Armure en cuivre pour nautile",
  "item.minecraft.copper_nugget": "Pépite de cuivre",
  "item.minecraft.copper_pickaxe": "Pioche en cuivre",
  "item.minecraft.copper_shovel": "Pelle en cuivre",
  "item.minecraft.copper_spear": "Lance en cuivre",
  "item.minecraft.copper_sword": "Épée en cuivre",
  "item.minecraft.cow_spawn_egg": "Oeuf spawneur de vache",
  "item.minecraft.creaking_spawn_egg": "Oeuf spawneur de grinceur",
  "item.minecraft.creeper_banner_pattern": "Motif de bannière",
  "item.minecraft.creeper_banner_pattern.desc": "Face de Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Motif de bannière de face de Creeper",
  "item.minecraft.creeper_spawn_egg": "Oeuf spawneur de Creeper",
  "item.minecraft.crossbow": "Arbalète",
  "item.minecraft.crossbow.projectile": "Projectile :",
  "item.minecraft.crossbow.projectile.multiple": "Projectile : %s × %s",
  "item.minecraft.crossbow.projectile.single": "Projectile : %s",
  "item.minecraft.cyan_bundle": "Sac cyan",
  "item.minecraft.cyan_dye": "Teinture cyan",
  "item.minecraft.cyan_harness": "Harnais cyan",
  "item.minecraft.danger_pottery_shard": "Tesson de poterie de danger",
  "item.minecraft.danger_pottery_sherd": "Tesson de poterie de danger",
  "item.minecraft.dark_oak_boat": "Bateau en chêne noir",
  "item.minecraft.dark_oak_chest_boat": "Bateau de stockage en chêne noir",
  "item.minecraft.debug_stick": "Bâton de débogage",
  "item.minecraft.debug_stick.empty": "%s n'a aucune propriété",
  "item.minecraft.debug_stick.select": "\"%s\" sélectionné (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" à %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Hache en diamant",
  "item.minecraft.diamond_boots": "Bottes en diamant",
  "item.minecraft.diamond_chestplate": "Plastron en diamant",
  "item.minecraft.diamond_helmet": "Casque en diamant",
  "item.minecraft.diamond_hoe": "Houe en diamant",
  "item.minecraft.diamond_horse_armor": "Armure en diamant pour cheval",
  "item.minecraft.diamond_leggings": "Jambières en diamant",
  "item.minecraft.diamond_nautilus_armor": "Armure en diamant pour nautile",
  "item.minecraft.diamond_pickaxe": "Pioche en diamant",
  "item.minecraft.diamond_shovel": "Pelle en diamant",
  "item.minecraft.diamond_spear": "Lance en diamant",
  "item.minecraft.diamond_sword": "Épée en diamant",
  "item.minecraft.disc_fragment_5": "Fragment de disque",
  "item.minecraft.disc_fragment_5.desc": "Disque de musique - 5",
  "item.minecraft.dolphin_spawn_egg": "Oeuf spawneur de dauphin",
  "item.minecraft.donkey_spawn_egg": "Oeuf spawneur d'âne",
  "item.minecraft.dragon_breath": "Fiole de souffle de dragon",
  "item.minecraft.dried_kelp": "Kelp séché",
  "item.minecraft.drowned_spawn_egg": "Oeuf spawneur de noyé",
  "item.minecraft.dune_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornement d'armure des dunes",
  "item.minecraft.echo_shard": "Éclat d'écho",
  "item.minecraft.egg": "Oeuf",
  "item.minecraft.elder_guardian_spawn_egg": "Oeuf spawneur de grand gardien",
  "item.minecraft.elytra": "Élytres",
  "item.minecraft.emerald": "Émeraude",
  "item.minecraft.enchanted_book": "Livre enchanté",
  "item.minecraft.enchanted_golden_apple": "Pomme dorée enchantée",
  "item.minecraft.end_crystal": "Cristal de l'End",
  "item.minecraft.ender_dragon_spawn_egg": "Oeuf spawneur d'Ender Dragon",
  "item.minecraft.ender_eye": "Oeil d'Ender",
  "item.minecraft.ender_pearl": "Ender perle",
  "item.minecraft.enderman_spawn_egg": "Oeuf spawneur d'Enderman",
  "item.minecraft.endermite_spawn_egg": "Oeuf spawneur d'Endermite",
  "item.minecraft.evoker_spawn_egg": "Oeuf spawneur d'évocateur",
  "item.minecraft.experience_bottle": "Fiole d'expérience",
  "item.minecraft.explorer_pottery_shard": "Tesson de poterie d'explorateur",
  "item.minecraft.explorer_pottery_sherd": "Tesson de poterie d'explorateur",
  "item.minecraft.eye_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornement d'armure des yeux",
  "item.minecraft.feather": "Plume",
  "item.minecraft.fermented_spider_eye": "Oeil d'araignée fermenté",
  "item.minecraft.field_masoned_banner_pattern": "Motif de bannière de champ maçonné",
  "item.minecraft.filled_map": "Carte",
  "item.minecraft.fire_charge": "Boule de feu",
  "item.minecraft.firework_rocket": "Fusée de feu d'artifice",
  "item.minecraft.firework_rocket.flight": "Durée de vol :",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Étoile de feu d'artifice",
  "item.minecraft.firework_star.black": "Noir",
  "item.minecraft.firework_star.blue": "Bleu",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Personnalisée",
  "item.minecraft.firework_star.cyan": "Cyan",
  "item.minecraft.firework_star.fade_to": "Fondu :",
  "item.minecraft.firework_star.flicker": "Étincelles",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Vert",
  "item.minecraft.firework_star.light_blue": "Bleu pâle",
  "item.minecraft.firework_star.light_gray": "Gris pâle",
  "item.minecraft.firework_star.lime": "Vert lime",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rose",
  "item.minecraft.firework_star.purple": "Mauve",
  "item.minecraft.firework_star.red": "Rouge",
  "item.minecraft.firework_star.shape": "Forme inconnue",
  "item.minecraft.firework_star.shape.burst": "Éclatement",
  "item.minecraft.firework_star.shape.creeper": "En face de Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Grosse boule",
  "item.minecraft.firework_star.shape.small_ball": "Petite boule",
  "item.minecraft.firework_star.shape.star": "En forme d'étoile",
  "item.minecraft.firework_star.trail": "Traînées",
  "item.minecraft.firework_star.white": "Blanc",
  "item.minecraft.firework_star.yellow": "Jaune",
  "item.minecraft.fishing_rod": "Canne à pêche",
  "item.minecraft.flint": "Silex",
  "item.minecraft.flint_and_steel": "Briquet",
  "item.minecraft.flow_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornement d'armure des tourbillons",
  "item.minecraft.flow_banner_pattern": "Motif de bannière",
  "item.minecraft.flow_banner_pattern.desc": "Tourbillon",
  "item.minecraft.flow_banner_pattern.new": "Motif de bannière de tourbillon",
  "item.minecraft.flow_pottery_sherd": "Tesson de poterie de tourbillon",
  "item.minecraft.flower_banner_pattern": "Motif de bannière",
  "item.minecraft.flower_banner_pattern.desc": "Fleur",
  "item.minecraft.flower_banner_pattern.new": "Motif de bannière de fleur",
  "item.minecraft.flower_pot": "Pot de fleurs",
  "item.minecraft.fox_spawn_egg": "Oeuf spawneur de renard",
  "item.minecraft.friend_pottery_shard": "Tesson de poterie d'ami",
  "item.minecraft.friend_pottery_sherd": "Tesson de poterie d'ami",
  "item.minecraft.frog_spawn_egg": "Oeuf spawneur de grenouille",
  "item.minecraft.furnace_minecart": "Wagonnet à vapeur",
  "item.minecraft.ghast_spawn_egg": "Oeuf spawneur de Ghast",
  "item.minecraft.ghast_tear": "Larme de Ghast",
  "item.minecraft.glass_bottle": "Fiole",
  "item.minecraft.glistering_melon_slice": "Tranche de melon d'eau scintillante",
  "item.minecraft.globe_banner_pattern": "Motif de bannière",
  "item.minecraft.globe_banner_pattern.desc": "Globe",
  "item.minecraft.globe_banner_pattern.new": "Motif de bannière de globe",
  "item.minecraft.glow_berries": "Baies lumineuses",
  "item.minecraft.glow_ink_sac": "Poche d'encre luisante",
  "item.minecraft.glow_item_frame": "Cadre luisant",
  "item.minecraft.glow_squid_spawn_egg": "Oeuf spawneur de pieuvre luisante",
  "item.minecraft.glowstone_dust": "Poudre de glowstone",
  "item.minecraft.goat_horn": "Corne de chèvre",
  "item.minecraft.goat_spawn_egg": "Oeuf spawneur de chèvre",
  "item.minecraft.gold_ingot": "Lingot d'or",
  "item.minecraft.gold_nugget": "Pépite d'or",
  "item.minecraft.golden_apple": "Pomme dorée",
  "item.minecraft.golden_axe": "Hache en or",
  "item.minecraft.golden_boots": "Bottes en or",
  "item.minecraft.golden_carrot": "Carotte dorée",
  "item.minecraft.golden_chestplate": "Plastron en or",
  "item.minecraft.golden_helmet": "Casque en or",
  "item.minecraft.golden_hoe": "Houe en or",
  "item.minecraft.golden_horse_armor": "Armure en or pour cheval",
  "item.minecraft.golden_leggings": "Jambières en or",
  "item.minecraft.golden_nautilus_armor": "Armure en or pour nautile",
  "item.minecraft.golden_pickaxe": "Pioche en or",
  "item.minecraft.golden_shovel": "Pelle en or",
  "item.minecraft.golden_spear": "Lance en or",
  "item.minecraft.golden_sword": "Épée en or",
  "item.minecraft.gray_bundle": "Sac gris",
  "item.minecraft.gray_dye": "Teinture grise",
  "item.minecraft.gray_harness": "Harnais gris",
  "item.minecraft.green_bundle": "Sac vert",
  "item.minecraft.green_dye": "Teinture verte",
  "item.minecraft.green_harness": "Harnais vert",
  "item.minecraft.guardian_spawn_egg": "Oeuf spawneur de gardien",
  "item.minecraft.gunpowder": "Poudre à canon",
  "item.minecraft.guster_banner_pattern": "Motif de bannière",
  "item.minecraft.guster_banner_pattern.desc": "Rafaleur",
  "item.minecraft.guster_banner_pattern.new": "Motif de bannière de rafaleur",
  "item.minecraft.guster_pottery_sherd": "Tesson de poterie de rafaleur",
  "item.minecraft.happy_ghast_spawn_egg": "Oeuf spawneur de gentil Ghast",
  "item.minecraft.harness": "Harnais",
  "item.minecraft.heart_of_the_sea": "Coeur de l'océan",
  "item.minecraft.heart_pottery_shard": "Tesson de poterie de coeur",
  "item.minecraft.heart_pottery_sherd": "Tesson de poterie de coeur",
  "item.minecraft.heartbreak_pottery_shard": "Tesson de poterie de coeur brisé",
  "item.minecraft.heartbreak_pottery_sherd": "Tesson de poterie de coeur brisé",
  "item.minecraft.hoglin_spawn_egg": "Oeuf spawneur de Hoglin",
  "item.minecraft.honey_bottle": "Fiole de miel",
  "item.minecraft.honeycomb": "Rayon de miel",
  "item.minecraft.hopper_minecart": "Wagonnet avec entonnoir",
  "item.minecraft.horse_spawn_egg": "Oeuf spawneur de cheval",
  "item.minecraft.host_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornement d'armure des hôtes",
  "item.minecraft.howl_pottery_shard": "Tesson de poterie de hurlement",
  "item.minecraft.howl_pottery_sherd": "Tesson de poterie de hurlement",
  "item.minecraft.husk_spawn_egg": "Oeuf spawneur de momifié",
  "item.minecraft.ink_sac": "Poche d'encre",
  "item.minecraft.iron_axe": "Hache en fer",
  "item.minecraft.iron_boots": "Bottes en fer",
  "item.minecraft.iron_chestplate": "Plastron en fer",
  "item.minecraft.iron_golem_spawn_egg": "Oeuf spawneur de golem de fer",
  "item.minecraft.iron_helmet": "Casque en fer",
  "item.minecraft.iron_hoe": "Houe en fer",
  "item.minecraft.iron_horse_armor": "Armure en fer pour cheval",
  "item.minecraft.iron_ingot": "Lingot de fer",
  "item.minecraft.iron_leggings": "Jambières en fer",
  "item.minecraft.iron_nautilus_armor": "Armure en fer pour nautile",
  "item.minecraft.iron_nugget": "Pépite de fer",
  "item.minecraft.iron_pickaxe": "Pioche en fer",
  "item.minecraft.iron_shovel": "Pelle en fer",
  "item.minecraft.iron_spear": "Lance en fer",
  "item.minecraft.iron_sword": "Épée en fer",
  "item.minecraft.item_frame": "Cadre",
  "item.minecraft.jungle_boat": "Bateau en acajou",
  "item.minecraft.jungle_chest_boat": "Bateau de stockage en acajou",
  "item.minecraft.knowledge_book": "Livre de connaissances",
  "item.minecraft.lapis_lazuli": "Lapis-lazuli",
  "item.minecraft.lava_bucket": "Chaudière de lave",
  "item.minecraft.lead": "Laisse",
  "item.minecraft.leather": "Cuir",
  "item.minecraft.leather_boots": "Bottes en cuir",
  "item.minecraft.leather_chestplate": "Tunique en cuir",
  "item.minecraft.leather_helmet": "Calotte en cuir",
  "item.minecraft.leather_horse_armor": "Armure en cuir pour cheval",
  "item.minecraft.leather_leggings": "Pantalon en cuir",
  "item.minecraft.light_blue_bundle": "Sac bleu pâle",
  "item.minecraft.light_blue_dye": "Teinture bleu pâle",
  "item.minecraft.light_blue_harness": "Harnais bleu pâle",
  "item.minecraft.light_gray_bundle": "Sac gris pâle",
  "item.minecraft.light_gray_dye": "Teinture gris pâle",
  "item.minecraft.light_gray_harness": "Harnais gris pâle",
  "item.minecraft.lime_bundle": "Sac vert lime",
  "item.minecraft.lime_dye": "Teinture vert lime",
  "item.minecraft.lime_harness": "Harnais vert lime",
  "item.minecraft.lingering_potion": "Potion persistante",
  "item.minecraft.lingering_potion.effect.awkward": "Potion délicate persistante",
  "item.minecraft.lingering_potion.effect.empty": "Potion persistante non craftable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Potion de résistance au feu persistante",
  "item.minecraft.lingering_potion.effect.harming": "Potion de dégâts persistante",
  "item.minecraft.lingering_potion.effect.healing": "Potion de guérison persistante",
  "item.minecraft.lingering_potion.effect.infested": "Potion d'infestation persistante",
  "item.minecraft.lingering_potion.effect.invisibility": "Potion d'invisibilité persistante",
  "item.minecraft.lingering_potion.effect.leaping": "Potion de saut persistante",
  "item.minecraft.lingering_potion.effect.levitation": "Potion de lévitation persistante",
  "item.minecraft.lingering_potion.effect.luck": "Potion de chance persistante",
  "item.minecraft.lingering_potion.effect.mundane": "Potion banale persistante",
  "item.minecraft.lingering_potion.effect.night_vision": "Potion de vision nocturne persistante",
  "item.minecraft.lingering_potion.effect.oozing": "Potion de sécrétion persistante",
  "item.minecraft.lingering_potion.effect.poison": "Potion de poison persistante",
  "item.minecraft.lingering_potion.effect.regeneration": "Potion de régénération persistante",
  "item.minecraft.lingering_potion.effect.slow_falling": "Potion de chute lente persistante",
  "item.minecraft.lingering_potion.effect.slowness": "Potion de lenteur persistante",
  "item.minecraft.lingering_potion.effect.strength": "Potion de force persistante",
  "item.minecraft.lingering_potion.effect.swiftness": "Potion de rapidité persistante",
  "item.minecraft.lingering_potion.effect.thick": "Potion épaisse persistante",
  "item.minecraft.lingering_potion.effect.turtle_master": "Potion du Maître Tortue persistante",
  "item.minecraft.lingering_potion.effect.water": "Fiole d'eau persistante",
  "item.minecraft.lingering_potion.effect.water_breathing": "Potion de respiration aquatique persistante",
  "item.minecraft.lingering_potion.effect.weakness": "Potion de faiblesse persistante",
  "item.minecraft.lingering_potion.effect.weaving": "Potion de tissage persistante",
  "item.minecraft.lingering_potion.effect.wind_charged": "Potion d'éclatement de vent persistante",
  "item.minecraft.llama_spawn_egg": "Oeuf spawneur de lama",
  "item.minecraft.lodestone_compass": "Boussole magnétisée",
  "item.minecraft.mace": "Masse",
  "item.minecraft.magenta_bundle": "Sac magenta",
  "item.minecraft.magenta_dye": "Teinture magenta",
  "item.minecraft.magenta_harness": "Harnais magenta",
  "item.minecraft.magma_cream": "Crème de magma",
  "item.minecraft.magma_cube_spawn_egg": "Oeuf spawneur de cube de magma",
  "item.minecraft.mangrove_boat": "Bateau en palétuvier",
  "item.minecraft.mangrove_chest_boat": "Bateau de stockage en palétuvier",
  "item.minecraft.map": "Carte vierge",
  "item.minecraft.melon_seeds": "Graines de melon d'eau",
  "item.minecraft.melon_slice": "Tranche de melon d'eau",
  "item.minecraft.milk_bucket": "Chaudière de lait",
  "item.minecraft.minecart": "Wagonnet",
  "item.minecraft.miner_pottery_shard": "Tesson de poterie de mineur",
  "item.minecraft.miner_pottery_sherd": "Tesson de poterie de mineur",
  "item.minecraft.mojang_banner_pattern": "Motif de bannière",
  "item.minecraft.mojang_banner_pattern.desc": "Emblème",
  "item.minecraft.mojang_banner_pattern.new": "Motif de bannière d'emblème",
  "item.minecraft.mooshroom_spawn_egg": "Oeuf spawneur de Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Tesson de poterie de gémisseur",
  "item.minecraft.mourner_pottery_sherd": "Tesson de poterie de gémisseur",
  "item.minecraft.mule_spawn_egg": "Oeuf spawneur de mule",
  "item.minecraft.mushroom_stew": "Crème de champignons",
  "item.minecraft.music_disc_11": "Disque de musique",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disque de musique",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disque de musique",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disque de musique",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disque de musique",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disque de musique",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disque de musique",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disque de musique",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Boîte à musique)",
  "item.minecraft.music_disc_far": "Disque de musique",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disque de musique",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disque de musique",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disque de musique",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disque de musique",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disque de musique",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disque de musique",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disque de musique",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disque de musique",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disque de musique",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disque de musique",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disque de musique",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disque de musique",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Mouton cru",
  "item.minecraft.name_tag": "Étiquette",
  "item.minecraft.nautilus_shell": "Coquille de nautile",
  "item.minecraft.nautilus_spawn_egg": "Oeuf spawneur de nautile",
  "item.minecraft.nether_brick": "Brique du Nether",
  "item.minecraft.nether_star": "Étoile du Nether",
  "item.minecraft.nether_wart": "Verrues du Nether",
  "item.minecraft.netherite_axe": "Hache en netherite",
  "item.minecraft.netherite_boots": "Bottes en netherite",
  "item.minecraft.netherite_chestplate": "Plastron en netherite",
  "item.minecraft.netherite_helmet": "Casque en netherite",
  "item.minecraft.netherite_hoe": "Houe en netherite",
  "item.minecraft.netherite_horse_armor": "Armure en netherite pour cheval",
  "item.minecraft.netherite_ingot": "Lingot de netherite",
  "item.minecraft.netherite_leggings": "Jambières en netherite",
  "item.minecraft.netherite_nautilus_armor": "Armure en netherite pour nautile",
  "item.minecraft.netherite_pickaxe": "Pioche en netherite",
  "item.minecraft.netherite_scrap": "Fragments de netherite",
  "item.minecraft.netherite_shovel": "Pelle en netherite",
  "item.minecraft.netherite_spear": "Lance en netherite",
  "item.minecraft.netherite_sword": "Épée en netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Modèle de forge",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Amélioration en netherite",
  "item.minecraft.oak_boat": "Bateau en chêne",
  "item.minecraft.oak_chest_boat": "Bateau de stockage en chêne",
  "item.minecraft.ocelot_spawn_egg": "Oeuf spawneur d'ocelot",
  "item.minecraft.ominous_bottle": "Fiole sinistre",
  "item.minecraft.ominous_trial_key": "Clé des épreuves sinistre",
  "item.minecraft.orange_bundle": "Sac orange",
  "item.minecraft.orange_dye": "Teinture orange",
  "item.minecraft.orange_harness": "Harnais orange",
  "item.minecraft.painting": "Tableau",
  "item.minecraft.pale_oak_boat": "Bateau en chêne blanc",
  "item.minecraft.pale_oak_chest_boat": "Bateau de stockage en chêne blanc",
  "item.minecraft.panda_spawn_egg": "Oeuf spawneur de panda",
  "item.minecraft.paper": "Papier",
  "item.minecraft.parched_spawn_egg": "Oeuf spawneur de desséché",
  "item.minecraft.parrot_spawn_egg": "Oeuf spawneur de perroquet",
  "item.minecraft.phantom_membrane": "Membrane de Phantom",
  "item.minecraft.phantom_spawn_egg": "Oeuf spawneur de Phantom",
  "item.minecraft.pig_spawn_egg": "Oeuf spawneur de cochon",
  "item.minecraft.piglin_banner_pattern": "Motif de bannière",
  "item.minecraft.piglin_banner_pattern.desc": "Groin",
  "item.minecraft.piglin_banner_pattern.new": "Motif de bannière de groin",
  "item.minecraft.piglin_brute_spawn_egg": "Oeuf spawneur de Piglin barbare",
  "item.minecraft.piglin_spawn_egg": "Oeuf spawneur de Piglin",
  "item.minecraft.pillager_spawn_egg": "Oeuf spawneur de pillageois",
  "item.minecraft.pink_bundle": "Sac rose",
  "item.minecraft.pink_dye": "Teinture rose",
  "item.minecraft.pink_harness": "Harnais rose",
  "item.minecraft.pitcher_plant": "Plante pichet",
  "item.minecraft.pitcher_pod": "Gousse de plante pichet",
  "item.minecraft.plenty_pottery_shard": "Tesson de poterie de richesse",
  "item.minecraft.plenty_pottery_sherd": "Tesson de poterie de richesse",
  "item.minecraft.poisonous_potato": "Patate toxique",
  "item.minecraft.polar_bear_spawn_egg": "Oeuf spawneur d'ours polaire",
  "item.minecraft.popped_chorus_fruit": "Fruit de chorus éclaté",
  "item.minecraft.porkchop": "Côtelette de porc crue",
  "item.minecraft.potato": "Patate",
  "item.minecraft.potion": "Potion",
  "item.minecraft.potion.effect.awkward": "Potion délicate",
  "item.minecraft.potion.effect.empty": "Potion non craftable",
  "item.minecraft.potion.effect.fire_resistance": "Potion de résistance au feu",
  "item.minecraft.potion.effect.harming": "Potion de dégâts",
  "item.minecraft.potion.effect.healing": "Potion de guérison",
  "item.minecraft.potion.effect.infested": "Potion d'infestation",
  "item.minecraft.potion.effect.invisibility": "Potion d'invisibilité",
  "item.minecraft.potion.effect.leaping": "Potion de saut",
  "item.minecraft.potion.effect.levitation": "Potion de lévitation",
  "item.minecraft.potion.effect.luck": "Potion de chance",
  "item.minecraft.potion.effect.mundane": "Potion banale",
  "item.minecraft.potion.effect.night_vision": "Potion de vision nocturne",
  "item.minecraft.potion.effect.oozing": "Potion de sécrétion",
  "item.minecraft.potion.effect.poison": "Potion de poison",
  "item.minecraft.potion.effect.regeneration": "Potion de régénération",
  "item.minecraft.potion.effect.slow_falling": "Potion de chute lente",
  "item.minecraft.potion.effect.slowness": "Potion de lenteur",
  "item.minecraft.potion.effect.strength": "Potion de force",
  "item.minecraft.potion.effect.swiftness": "Potion de rapidité",
  "item.minecraft.potion.effect.thick": "Potion épaisse",
  "item.minecraft.potion.effect.turtle_master": "Potion du Maître Tortue",
  "item.minecraft.potion.effect.water": "Fiole d'eau",
  "item.minecraft.potion.effect.water_breathing": "Potion de respiration aquatique",
  "item.minecraft.potion.effect.weakness": "Potion de faiblesse",
  "item.minecraft.potion.effect.weaving": "Potion de tissage",
  "item.minecraft.potion.effect.wind_charged": "Potion d'éclatement de vent",
  "item.minecraft.pottery_shard_archer": "Tesson de poterie d'archer",
  "item.minecraft.pottery_shard_arms_up": "Tesson de poterie de mains en l'air",
  "item.minecraft.pottery_shard_prize": "Tesson de poterie de joyau",
  "item.minecraft.pottery_shard_skull": "Tesson de poterie de crâne",
  "item.minecraft.powder_snow_bucket": "Chaudière de neige poudreuse",
  "item.minecraft.prismarine_crystals": "Cristaux de prismarine",
  "item.minecraft.prismarine_shard": "Éclat de prismarine",
  "item.minecraft.prize_pottery_shard": "Tesson de poterie de joyau",
  "item.minecraft.prize_pottery_sherd": "Tesson de poterie de joyau",
  "item.minecraft.pufferfish": "Fugu",
  "item.minecraft.pufferfish_bucket": "Fugu dans une chaudière",
  "item.minecraft.pufferfish_spawn_egg": "Oeuf spawneur de fugu",
  "item.minecraft.pumpkin_pie": "Tarte à la citrouille",
  "item.minecraft.pumpkin_seeds": "Graines de citrouille",
  "item.minecraft.purple_bundle": "Sac mauve",
  "item.minecraft.purple_dye": "Teinture mauve",
  "item.minecraft.purple_harness": "Harnais mauve",
  "item.minecraft.quartz": "Quartz du Nether",
  "item.minecraft.rabbit": "Lapin cru",
  "item.minecraft.rabbit_foot": "Patte de lapin",
  "item.minecraft.rabbit_hide": "Peau de lapin",
  "item.minecraft.rabbit_spawn_egg": "Oeuf spawneur de lapin",
  "item.minecraft.rabbit_stew": "Ragoût de lapin",
  "item.minecraft.raiser_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornement d'armure des éleveurs",
  "item.minecraft.ravager_spawn_egg": "Oeuf spawneur de ravageur",
  "item.minecraft.raw_copper": "Cuivre brut",
  "item.minecraft.raw_gold": "Or brut",
  "item.minecraft.raw_iron": "Fer brut",
  "item.minecraft.recovery_compass": "Boussole de récupération",
  "item.minecraft.red_bundle": "Sac rouge",
  "item.minecraft.red_dye": "Teinture rouge",
  "item.minecraft.red_harness": "Harnais rouge",
  "item.minecraft.redstone": "Poudre de redstone",
  "item.minecraft.resin_brick": "Brique de résine",
  "item.minecraft.resin_clump": "Motte de résine",
  "item.minecraft.rib_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornement d'armure des côtes",
  "item.minecraft.rotten_flesh": "Chair pourrie",
  "item.minecraft.saddle": "Selle",
  "item.minecraft.salmon": "Saumon cru",
  "item.minecraft.salmon_bucket": "Saumon dans une chaudière",
  "item.minecraft.salmon_spawn_egg": "Oeuf spawneur de saumon",
  "item.minecraft.scrape_pottery_sherd": "Tesson de poterie de décapage",
  "item.minecraft.scute": "Scutelle",
  "item.minecraft.sentry_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornement d'armure des sentinelles",
  "item.minecraft.shaper_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornement d'armure des façonneurs",
  "item.minecraft.sheaf_pottery_shard": "Tesson de poterie de gerbe",
  "item.minecraft.sheaf_pottery_sherd": "Tesson de poterie de gerbe",
  "item.minecraft.shears": "Cisailles",
  "item.minecraft.sheep_spawn_egg": "Oeuf spawneur de mouton",
  "item.minecraft.shelter_pottery_shard": "Tesson de poterie d'abri",
  "item.minecraft.shelter_pottery_sherd": "Tesson de poterie d'abri",
  "item.minecraft.shield": "Bouclier",
  "item.minecraft.shield.black": "Bouclier de sable",
  "item.minecraft.shield.blue": "Bouclier d'azur",
  "item.minecraft.shield.brown": "Bouclier de tanné",
  "item.minecraft.shield.cyan": "Bouclier de cyan",
  "item.minecraft.shield.gray": "Bouclier d'acier",
  "item.minecraft.shield.green": "Bouclier de sinople",
  "item.minecraft.shield.light_blue": "Bouclier de bleu céleste",
  "item.minecraft.shield.light_gray": "Bouclier d'argent grisé",
  "item.minecraft.shield.lime": "Bouclier de sinople clair",
  "item.minecraft.shield.magenta": "Bouclier de pourpre",
  "item.minecraft.shield.orange": "Bouclier d'orangé",
  "item.minecraft.shield.pink": "Bouclier de carnation",
  "item.minecraft.shield.purple": "Bouclier de mûre",
  "item.minecraft.shield.red": "Bouclier de gueules",
  "item.minecraft.shield.white": "Bouclier d'argent",
  "item.minecraft.shield.yellow": "Bouclier d'or",
  "item.minecraft.shulker_shell": "Carapace de Shulker",
  "item.minecraft.shulker_spawn_egg": "Oeuf spawneur de Shulker",
  "item.minecraft.sign": "Pancarte",
  "item.minecraft.silence_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornement d'armure du silence",
  "item.minecraft.silverfish_spawn_egg": "Oeuf spawneur de poisson d'argent",
  "item.minecraft.skeleton_horse_spawn_egg": "Oeuf spawneur de cheval-squelette",
  "item.minecraft.skeleton_spawn_egg": "Oeuf spawneur de squelette",
  "item.minecraft.skull_banner_pattern": "Motif de bannière",
  "item.minecraft.skull_banner_pattern.desc": "Tête de mort",
  "item.minecraft.skull_banner_pattern.new": "Motif de bannière de tête de mort",
  "item.minecraft.skull_pottery_shard": "Tesson de poterie de crâne",
  "item.minecraft.skull_pottery_sherd": "Tesson de poterie de crâne",
  "item.minecraft.slime_ball": "Boule de slime",
  "item.minecraft.slime_spawn_egg": "Oeuf spawneur de Slime",
  "item.minecraft.smithing_template": "Modèle de forge",
  "item.minecraft.smithing_template.applies_to": "S'applique à :",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Ajoutez un lingot ou un cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armure",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Ajoutez une pièce d'armure",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingots et cristaux",
  "item.minecraft.smithing_template.ingredients": "Ingrédients :",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Ajoutez un lingot de netherite",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Équipement en diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Ajoutez une pièce d'armure, une arme ou un outil en diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingot de netherite",
  "item.minecraft.smithing_template.upgrade": "Amélioration : ",
  "item.minecraft.sniffer_spawn_egg": "Oeuf spawneur de renifleur",
  "item.minecraft.snort_pottery_shard": "Tesson de poterie de reniflement",
  "item.minecraft.snort_pottery_sherd": "Tesson de poterie de reniflement",
  "item.minecraft.snout_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornement d'armure des groins",
  "item.minecraft.snow_golem_spawn_egg": "Oeuf spawneur de golem de neige",
  "item.minecraft.snowball": "Boule de neige",
  "item.minecraft.spectral_arrow": "Flèche spectrale",
  "item.minecraft.spider_eye": "Oeil d'araignée",
  "item.minecraft.spider_spawn_egg": "Oeuf spawneur d'araignée",
  "item.minecraft.spire_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornement d'armure des tours",
  "item.minecraft.splash_potion": "Potion jetable",
  "item.minecraft.splash_potion.effect.awkward": "Potion délicate jetable",
  "item.minecraft.splash_potion.effect.empty": "Potion jetable non craftable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Potion de résistance au feu jetable",
  "item.minecraft.splash_potion.effect.harming": "Potion de dégâts jetable",
  "item.minecraft.splash_potion.effect.healing": "Potion de guérison jetable",
  "item.minecraft.splash_potion.effect.infested": "Potion d'infestation jetable",
  "item.minecraft.splash_potion.effect.invisibility": "Potion d'invisibilité jetable",
  "item.minecraft.splash_potion.effect.leaping": "Potion de saut jetable",
  "item.minecraft.splash_potion.effect.levitation": "Potion de lévitation jetable",
  "item.minecraft.splash_potion.effect.luck": "Potion de chance jetable",
  "item.minecraft.splash_potion.effect.mundane": "Potion banale jetable",
  "item.minecraft.splash_potion.effect.night_vision": "Potion de vision nocturne jetable",
  "item.minecraft.splash_potion.effect.oozing": "Potion de sécrétion jetable",
  "item.minecraft.splash_potion.effect.poison": "Potion de poison jetable",
  "item.minecraft.splash_potion.effect.regeneration": "Potion de régénération jetable",
  "item.minecraft.splash_potion.effect.slow_falling": "Potion de chute lente jetable",
  "item.minecraft.splash_potion.effect.slowness": "Potion de lenteur jetable",
  "item.minecraft.splash_potion.effect.strength": "Potion de force jetable",
  "item.minecraft.splash_potion.effect.swiftness": "Potion de rapidité jetable",
  "item.minecraft.splash_potion.effect.thick": "Potion épaisse jetable",
  "item.minecraft.splash_potion.effect.turtle_master": "Potion du Maître Tortue jetable",
  "item.minecraft.splash_potion.effect.water": "Fiole d'eau jetable",
  "item.minecraft.splash_potion.effect.water_breathing": "Potion de respiration aquatique jetable",
  "item.minecraft.splash_potion.effect.weakness": "Potion de faiblesse jetable",
  "item.minecraft.splash_potion.effect.weaving": "Potion de tissage jetable",
  "item.minecraft.splash_potion.effect.wind_charged": "Potion d'éclatement de vent jetable",
  "item.minecraft.spruce_boat": "Bateau en épinette",
  "item.minecraft.spruce_chest_boat": "Bateau de stockage en épinette",
  "item.minecraft.spyglass": "Longue-vue",
  "item.minecraft.squid_spawn_egg": "Oeuf spawneur de pieuvre",
  "item.minecraft.stick": "Bâton",
  "item.minecraft.stone_axe": "Hache en pierre",
  "item.minecraft.stone_hoe": "Houe en pierre",
  "item.minecraft.stone_pickaxe": "Pioche en pierre",
  "item.minecraft.stone_shovel": "Pelle en pierre",
  "item.minecraft.stone_spear": "Lance en pierre",
  "item.minecraft.stone_sword": "Épée en pierre",
  "item.minecraft.stray_spawn_egg": "Oeuf spawneur de rôdeur",
  "item.minecraft.strider_spawn_egg": "Oeuf spawneur d'arpenteur",
  "item.minecraft.string": "Fil",
  "item.minecraft.sugar": "Sucre",
  "item.minecraft.suspicious_stew": "Soupe suspecte",
  "item.minecraft.sweet_berries": "Baies sucrées",
  "item.minecraft.tadpole_bucket": "Têtard dans une chaudière",
  "item.minecraft.tadpole_spawn_egg": "Oeuf spawneur de têtard",
  "item.minecraft.tide_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornement d'armure des marées",
  "item.minecraft.tipped_arrow": "Flèche trempée",
  "item.minecraft.tipped_arrow.effect.awkward": "Flèche trempée de potion délicate",
  "item.minecraft.tipped_arrow.effect.empty": "Flèche trempée non craftable",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flèche de résistance au feu",
  "item.minecraft.tipped_arrow.effect.harming": "Flèche de dégâts",
  "item.minecraft.tipped_arrow.effect.healing": "Flèche de guérison",
  "item.minecraft.tipped_arrow.effect.infested": "Flèche d'infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flèche d'invisibilité",
  "item.minecraft.tipped_arrow.effect.leaping": "Flèche de saut",
  "item.minecraft.tipped_arrow.effect.levitation": "Flèche de lévitation",
  "item.minecraft.tipped_arrow.effect.luck": "Flèche de chance",
  "item.minecraft.tipped_arrow.effect.mundane": "Flèche trempée de potion banale",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flèche de vision nocturne",
  "item.minecraft.tipped_arrow.effect.oozing": "Flèche de sécrétion",
  "item.minecraft.tipped_arrow.effect.poison": "Flèche de poison",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flèche de régénération",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flèche de chute lente",
  "item.minecraft.tipped_arrow.effect.slowness": "Flèche de lenteur",
  "item.minecraft.tipped_arrow.effect.strength": "Flèche de force",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flèche de rapidité",
  "item.minecraft.tipped_arrow.effect.thick": "Flèche trempée de potion épaisse",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flèche du Maître Tortue",
  "item.minecraft.tipped_arrow.effect.water": "Flèche à eau",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flèche de respiration aquatique",
  "item.minecraft.tipped_arrow.effect.weakness": "Flèche de faiblesse",
  "item.minecraft.tipped_arrow.effect.weaving": "Flèche de tissage",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flèche d'éclatement de vent",
  "item.minecraft.tnt_minecart": "Wagonnet avec TNT",
  "item.minecraft.torchflower_seeds": "Graines de torche-fleur",
  "item.minecraft.totem_of_undying": "Totem d'immortalité",
  "item.minecraft.trader_llama_spawn_egg": "Oeuf spawneur de lama de marchand",
  "item.minecraft.trial_key": "Clé des épreuves",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Poisson tropical",
  "item.minecraft.tropical_fish_bucket": "Poisson tropical dans une chaudière",
  "item.minecraft.tropical_fish_spawn_egg": "Oeuf spawneur de poisson tropical",
  "item.minecraft.turtle_helmet": "Carapace de tortue",
  "item.minecraft.turtle_scute": "Scutelle de tortue",
  "item.minecraft.turtle_spawn_egg": "Oeuf spawneur de tortue",
  "item.minecraft.vex_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornement d'armure des Vex",
  "item.minecraft.vex_spawn_egg": "Oeuf spawneur de Vex",
  "item.minecraft.villager_spawn_egg": "Oeuf spawneur de villageois",
  "item.minecraft.vindicator_spawn_egg": "Oeuf spawneur de vindicateur",
  "item.minecraft.wandering_trader_spawn_egg": "Oeuf spawneur de marchand ambulant",
  "item.minecraft.ward_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornement d'armure des gardiens",
  "item.minecraft.warden_spawn_egg": "Oeuf spawneur de Warden",
  "item.minecraft.warped_fungus_on_a_stick": "Champignon tordu sur un bâton",
  "item.minecraft.water_bucket": "Chaudière d'eau",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornement d'armure des guides",
  "item.minecraft.wheat": "Blé",
  "item.minecraft.wheat_seeds": "Graines de blé",
  "item.minecraft.white_bundle": "Sac blanc",
  "item.minecraft.white_dye": "Teinture blanche",
  "item.minecraft.white_harness": "Harnais blanc",
  "item.minecraft.wild_armor_trim_smithing_template": "Modèle de forge",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornement d'armure sauvage",
  "item.minecraft.wind_charge": "Charge de vent",
  "item.minecraft.witch_spawn_egg": "Oeuf spawneur de sorcière",
  "item.minecraft.wither_skeleton_spawn_egg": "Oeuf spawneur de squelette Wither",
  "item.minecraft.wither_spawn_egg": "Oeuf spawneur de Wither",
  "item.minecraft.wolf_armor": "Armure pour loup",
  "item.minecraft.wolf_spawn_egg": "Oeuf spawneur de loup",
  "item.minecraft.wooden_axe": "Hache en bois",
  "item.minecraft.wooden_hoe": "Houe en bois",
  "item.minecraft.wooden_pickaxe": "Pioche en bois",
  "item.minecraft.wooden_shovel": "Pelle en bois",
  "item.minecraft.wooden_spear": "Lance en bois",
  "item.minecraft.wooden_sword": "Épée en bois",
  "item.minecraft.writable_book": "Livre et plume",
  "item.minecraft.written_book": "Manuscrit",
  "item.minecraft.yellow_bundle": "Sac jaune",
  "item.minecraft.yellow_dye": "Teinture jaune",
  "item.minecraft.yellow_harness": "Harnais jaune",
  "item.minecraft.zoglin_spawn_egg": "Oeuf spawneur de Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Oeuf spawneur de cheval-zombie",
  "item.minecraft.zombie_nautilus_spawn_egg": "Oeuf spawneur de nautile-zombie",
  "item.minecraft.zombie_spawn_egg": "Oeuf spawneur de zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Oeuf spawneur de zombie-villageois",
  "item.minecraft.zombified_piglin_spawn_egg": "Oeuf spawneur de Piglin zombifié"
}
export const fr_ca = items; 
